let timer;
let callbackDelay = 1500;
let cartItemsQueue = new Map();
// Debounced cart count refresh so multiple operations only trigger one reload
let _cartCountRefreshTimer = null;
function scheduleCartCountRefresh(delay = 150) {
    if (_cartCountRefreshTimer) clearTimeout(_cartCountRefreshTimer);
    _cartCountRefreshTimer = setTimeout(() => {
        $('.CartCount').load(location.href + ' .CartCount', '');
        _cartCountRefreshTimer = null;
    }, delay);
}

let _cartSubtotalRefreshTimer = null;
function scheduleCartSubtotalRefresh(delay = 150) {
    if (_cartSubtotalRefreshTimer) clearTimeout(_cartSubtotalRefreshTimer);
    _cartSubtotalRefreshTimer = setTimeout(() => {
        $('.CartSubtotal').load(location.href + ' .CartSubtotal', '');
        _cartSubtotalRefreshTimer = null;
    }, delay);
}

// Inline feedback helper for quantity limits
function showQuantityFeedback(boxEl, message, duration = 3000) {
    try {
        if (!boxEl) return;
        let container = boxEl.parentElement;
        let feedback = null;
        if (container) feedback = container.querySelector(':scope > .error-message');
        if (!feedback) {
            let next = boxEl.nextElementSibling;
            if (next && next.classList && next.classList.contains('error-message')) feedback = next;
        }
        if (!feedback) {
            // Fallback create if missing
            feedback = document.createElement('div');
            feedback.className = 'error-message';
            feedback.style.fontSize = '12px';
            feedback.style.marginTop = '4px';
            feedback.style.color = '#c0392b';
            if (container) container.appendChild(feedback); else boxEl.appendChild(feedback);
        }
        feedback.textContent = message;
        feedback.classList.add('visible');
        if (feedback._timeout) { clearTimeout(feedback._timeout); feedback._timeout = null; }
        if (duration > 0) {
            feedback._timeout = setTimeout(() => { feedback.classList.remove('visible'); }, duration);
        }
    } catch(e) { /* silent */ }
}

// Remove quantity feedback message (if present) for a given quantity box
function clearQuantityFeedback(boxEl) {
    try {
        if (!boxEl) return;
        const container = boxEl.parentElement;
        const feedback = container ? container.querySelector(':scope > .error-message') : null;
        if (feedback) {
            if (feedback._timeout) { clearTimeout(feedback._timeout); feedback._timeout = null; }
            feedback.classList.remove('visible');
            feedback.textContent = '';
        }
    } catch(e) { /* silent */ }
}

// Helper function to expand future stock section
function expandFutureStock(variantItem) {
    const $variantItem = $(variantItem);
    const $futureStock = $variantItem.find('.variant-item__future-stock');
    const $header = $variantItem.find('.variant-item__header').first();
    
    // Only expand if not already visible
    if ($futureStock.length && !$futureStock.is(':visible')) {
        $futureStock.stop(true, false).slideDown('fast');
        $header.addClass('active');
    }
}

// Build despatch properties object from variant DOM element
function buildDespatchPropertiesFromVariant(variantItem, isPreorder = false) {
    const properties = {};
    const poNumbers = [];
    const poLineIDs = [];
    const isFabric = !!variantItem.querySelector('.quantity-input[data-value-actual]');
    const formatQty = (q) => isFabric ? `${q / 10}m` : String(q);

    // Vendor delay (Voyage Maison only)
    const vendor = variantItem.getAttribute('data-vendor');
    const delayDays = parseInt(variantItem.getAttribute('data-despatch-delay') || "0", 10);

    // Add days to a DD/MM/YYYY string
    const applyDelay = (dateStr) => {
        if (!vendor || vendor !== 'Voyage Maison' || !delayDays) return dateStr;

        const parts = dateStr.split('/');
        const d = parseInt(parts[0], 10);
        const m = parseInt(parts[1], 10) - 1;
        const y = parseInt(parts[2], 10);

        const base = new Date(y, m, d);
        base.setDate(base.getDate() + delayDays);

        const dd = String(base.getDate()).padStart(2, '0');
        const mm = String(base.getMonth() + 1).padStart(2, '0');
        const yyyy = base.getFullYear();

        return `${dd}/${mm}/${yyyy}`;
    };

    // Helper to add a despatch property
    const addDespatchProperty = (date, qty, sourceInput = null) => {
        if (!qty || qty <= 0) return;

        if (date === "immediate") {
            // If vendor delay applies, adjust today’s date
            if (vendor === "Voyage Maison" && delayDays > 0) {
                const now = new Date();
                now.setDate(now.getDate() + delayDays);

                const dd = String(now.getDate()).padStart(2, "0");
                const mm = String(now.getMonth() + 1).padStart(2, "0");
                const yyyy = now.getFullYear();

                const delayedDate = `${dd}/${mm}/${yyyy}`;

                properties[`Despatch ${delayedDate}`] = formatQty(qty);
                return;
            }

            // Otherwise normal immediate despatch
            properties["Despatch Immediately"] = formatQty(qty);
            return;
        } else {
            const adjustedDate = applyDelay(date);
            properties[`Despatch ${adjustedDate}`] = formatQty(qty);
        }
    };

    // Base qty (immediate or preorder)
    const baseInput = variantItem.querySelector('.variant-item__qty input.quantity-input:not(.future-quantity-input)');
    let baseQty = 0;

    if (baseInput) {
        if (isFabric && baseInput.hasAttribute('data-value-actual'))
            baseQty = parseInt(baseInput.getAttribute('data-value-actual'), 10) || 0;
        else
            baseQty = parseInt(baseInput.value, 10) || 0;

        const preorderDate = isPreorder ? baseInput.getAttribute('data-expected-date') : null;

        if (isPreorder && preorderDate) {
            addDespatchProperty(preorderDate, baseQty, baseInput);
        } else {
            addDespatchProperty("immediate", baseQty, baseInput);
        }
    }

    // Future dated (non-preorder)
    let hasFutureStock = false;
    if (!isPreorder) {
        const futureInputs = variantItem.querySelectorAll('.future-quantity-input');
        futureInputs.forEach(inp => {
            let qty = inp.hasAttribute('data-value-actual')
                ? parseInt(inp.getAttribute('data-value-actual'), 10) || 0
                : parseInt(inp.value, 10) || 0;

            const date = inp.getAttribute('data-expected-date');
            if (qty > 0 && date) {
                addDespatchProperty(date, qty);
                hasFutureStock = true;
            }

            if (qty > 0 && date) {
                const poNumber = inp.getAttribute('data-po-number');
                if (poNumber) {
                    poNumbers.push(`${poNumber}`);
                }

                const poLineId = inp.getAttribute('data-po-line-id');
                if (poLineId) {
                    poLineIDs.push(`${poLineId}`);
                }
            }
        });
    }

    if (poNumbers.length > 0) {
        properties['_po_number'] = poNumbers.join('; ');
    }

    if (poLineIDs.length > 0) {
        properties['_po_line_id'] = poLineIDs.join('; ');
    }
    
    // Minimum length for rolls and remnants (include if baseQty OR future stock exists)
    const itemType = variantItem.getAttribute('data-item-type');
    if ((itemType === 'roll' || itemType === 'remnant') && (baseQty > 0 || hasFutureStock)) {
        const minLengthInputs = variantItem.querySelectorAll('.min-length-input');
        if (minLengthInputs.length > 0) {
            minLengthInputs.forEach((input, index) => {
                const minLengthValue = input.value.replace('m', '').trim();
                const minLength = parseFloat(minLengthValue);
                // Only include if value is greater than 0
                if (minLength > 0) {
                    const rollNumber = index + 1;
                    properties[`Min Length Roll ${rollNumber}`] = minLength + 'm';
                }
            });
        }
    }
    
    return properties;
}

// Update DOM input state after successful cart operation
function updateInputState(input) {
    const qty = parseInt(input.value, 10) || 0;
    const oldQty = input.getAttribute('data-previous-quantity');
    
    input.setAttribute('data-value', qty);
    input.setAttribute('data-previous-quantity', qty);

    const container = input.closest('.quantity-box');
    if (container && qty != oldQty) {
        container.classList.remove('quantity-changed');
        container.classList.add('quantity-in-cart');
        updateButtonState();
    }
}

// Update all inputs for a variant (both regular and preorder versions)
function updateAllVariantInputs(variantId) {
    const allInputs = document.querySelectorAll(`input.quantity-input[data-variant-id="${variantId}"]`);
    allInputs.forEach(input => {
        const isFabric = input.hasAttribute('data-value-actual');
        let qty;
        
        if (isFabric) {
            qty = parseInt(input.getAttribute('data-value-actual'), 10) || 0;
            input.setAttribute('data-value-actual', qty);
            input.setAttribute('data-value', qty);
        } else {
            qty = parseInt(input.value, 10) || 0;
            input.setAttribute('data-value', qty);
        }
        
        input.setAttribute('data-previous-quantity', qty);

        const container = input.closest('.quantity-box');
        if (container) {
            container.classList.remove('quantity-changed');
            if (qty > 0) {
                container.classList.add('quantity-in-cart');
            }
        }
    });
    updateButtonState();
}

// Consolidate a variant to a single line item with despatch properties
async function consolidateVariantToSingleLine(productId, variantId, variantItem, isPreorder = false) {
    try {
        const isFabric = !!variantItem.querySelector('.quantity-input[data-value-actual]');
        
        // Calculate total quantity
        const baseInput = variantItem.querySelector('.variant-item__qty input.quantity-input:not(.future-quantity-input)');
        let total = 0;
        if (baseInput) {
            let baseQty;
            let availableNow;

            if (isFabric && baseInput.hasAttribute('data-value-actual')) {
                // Fabric quantities are represented in 0.1m units so times values by 10
                baseQty = parseInt(baseInput.getAttribute('data-value-actual'), 10) || 0;
                availableNow = parseInt(baseInput.getAttribute('max'), 10);

                if (!isNaN(availableNow)) {
                    availableNow *= 10;
                    baseQty = Math.min(baseQty, availableNow);
                }
            } else {
                baseQty = parseInt(baseInput.value, 10) || 0;
                availableNow = parseInt(baseInput.getAttribute('max'), 10);

                if (!isNaN(availableNow)) {
                    baseQty = Math.min(baseQty, availableNow);
                }
            }

            total += baseQty;
        }

        const futureInputs = variantItem.querySelectorAll('.future-quantity-input');
        futureInputs.forEach(inp => {
            if (isFabric && inp.hasAttribute('data-value-actual')) {
                total += parseInt(inp.getAttribute('data-value-actual'), 10) || 0;
            } else {
                total += parseInt(inp.value, 10) || 0;
            }
        });
        
        // Build properties
        const despatchProps = buildDespatchPropertiesFromVariant(variantItem, isPreorder);
        const baseProperties = {};
        
        // Add preorder identifier if this is a preorder variant
        if (isPreorder) {
            baseProperties['_preorder'] = 'true';
            // Store expected date for phantom preorders to differentiate them
            const expectedDate = baseInput?.getAttribute('data-expected-date');
            if (expectedDate) {
                baseProperties['_expected_date'] = expectedDate;
            }
        }
        
        // Add standard properties
        const itemPrice = variantItem.getAttribute('data-item-price');
        const itemType = variantItem.getAttribute('data-item-type');
        const variantStock = variantItem.getAttribute('data-item-variant-in-stock');
        const maxAttr = baseInput?.getAttribute('max');
        
        if (itemType === 'Fabric') {
            const pricePerMetre = variantItem.getAttribute('data-item-price-per-metre');
            if (pricePerMetre) baseProperties['_Price per metre'] = `${pricePerMetre}/metre`;
        } else {
            if (itemPrice) baseProperties['_item_price'] = itemPrice;
            if (variantStock) baseProperties['_in_stock'] = parseInt(variantStock, 10);
            if (maxAttr) baseProperties['_max'] = parseInt(maxAttr, 10);
        }
        
        // Merge despatch properties
        const allProperties = { ...baseProperties, ...despatchProps };
        
        // Fetch current cart
        const cart = await fetch(`${Shopify.routes.root}cart.js`).then(r => r.json());
        const matches = [];
        const expectedDate = isPreorder ? baseInput?.getAttribute('data-expected-date') : null;
        
        cart.items.forEach((ci, idx) => {
            if (ci.variant_id === parseInt(variantId, 10)) {
                // For phantom preorders, match by variant ID, _preorder property, AND expected date
                if (isPreorder) {
                    if (ci.properties && ci.properties._preorder === 'true') {
                        // If we have an expected date, it must match; otherwise just match on _preorder
                        if (expectedDate) {
                            if (ci.properties._expected_date === expectedDate) {
                                matches.push({ item: ci, line: idx + 1 });
                            }
                        } else {
                            matches.push({ item: ci, line: idx + 1 });
                        }
                    }
                } else {
                    // For regular items, match by variant ID but NOT preorder
                    if (!ci.properties || ci.properties._preorder !== 'true') {
                        matches.push({ item: ci, line: idx + 1 });
                    }
                }
            }
        });
        
        if (!matches.length) {
            // No existing line
            if (total > 0) {
                const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: total, properties: allProperties }] })
                });
                if (!response.ok) {
                    console.error('Failed to add to cart:', await response.text());
                    return;
                }
            }
            
            // Update all variant inputs (both regular and preorder) after successful add
            updateAllVariantInputs(variantId);
            return;
        }
        
        // Remove all but first line
        for (let i = 1; i < matches.length; i++) {
            const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ line: matches[i].line, quantity: 0 })
            });
            if (!response.ok) {
                console.error('Failed to remove duplicate line:', await response.text());
                return;
            }
        }
        
        // Update first line with total and properties
        let updateResponse;
        if (total > 0) {
            updateResponse = await fetch(`${Shopify.routes.root}cart/change.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ line: matches[0].line, quantity: total, properties: allProperties })
            });
        } else {
            // Remove if total is 0
            updateResponse = await fetch(`${Shopify.routes.root}cart/change.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ line: matches[0].line, quantity: 0 })
            });
        }
        
        if (!updateResponse.ok) {
            console.error('Failed to update cart line:', await updateResponse.text());
            return;
        }
        
        // Update all variant inputs (both regular and preorder) after successful cart operations
        updateAllVariantInputs(variantId);
    } catch(e) {
        console.error('Error consolidating variant:', e);
    }
}

// Calculate despatch splits for a cart item based on variant metafields
const calculateDespatchSplits = (item, variantMetafields) => {
    const variantId = item.variant_id;
    const metafields = variantMetafields[variantId];
    
    if (!metafields || !metafields.due_json) {
        return [{ date: 'Immediately', quantity: item.quantity }];
    }
    
    const dueJson = metafields.due_json;
    const availableNow = dueJson.availableNow || 0;
    const availability = dueJson.availability || [];
    
    let splits = [];
    let remainingQty = item.quantity;
    
    // First, handle availableNow for immediate despatch
    if (availableNow > 0 && remainingQty > 0) {
        const qtyForNow = Math.min(availableNow, remainingQty);
        splits.push({ date: 'Immediately', quantity: qtyForNow });
        remainingQty -= qtyForNow;
    }
    
    // Then process future availability dates
    if (availability.length > 0 && remainingQty > 0) {
        for (const avail of availability) {
            if (remainingQty <= 0) break;
            
            const availQty = avail.availableQty || 0;
            if (availQty > 0) {
                const qtyForDate = Math.min(availQty, remainingQty);
                splits.push({ date: avail.date, quantity: qtyForDate, poNumber: avail.poNumber || null, poLineId: avail.poLineId || null });
                remainingQty -= qtyForDate;
            }
        }
    }
    
    // Handle remaining quantity (insufficient stock)
    if (remainingQty > 0) {
        splits.push({ date: 'Insufficient Stock', quantity: remainingQty });
    }
    
    return splits;
};

// Format despatch splits as a line item property string
const formatDespatchProperty = (splits, isFabric = false) => {
    const formatQty = (qty) => isFabric ? `${qty / 10}m` : qty;
    
    if (splits.length === 1) {
        // Single despatch date - simple format
        return `${splits[0].date}: ${formatQty(splits[0].quantity)}`;
    }
    // Multiple despatch dates - use semicolon separator for better readability in checkout
    return splits.map(split => `${split.date}: ${formatQty(split.quantity)}`).join('; ');
};

const updateAjaxCartItems = () => {
    fetch(`${Shopify.routes.root}cart.js`)
        .then(response => response.json())
        .then(parsedCart => {
            const itemsInCart = parsedCart.items;
            let items = [];

            itemsInCart.forEach((itemInCart, index) => {
                // When cut length update number of metres from quantity
                if (itemInCart.sku.endsWith('+M')) {
                    let existingProperties = itemInCart.properties || {};
                    existingProperties["Number Of Metres"] = (itemInCart.quantity / 10) + "m";

                    items.push({
                        index: index + 1,
                        existingProperties,
                        quantity: itemInCart.quantity
                    });
                }
            });

            if (items.length > 0) {
                let i = 0;

                const updateItemsInOrder = () => {
                    const item = items[i];
                    if (!item) return;

                    fetch(`${Shopify.routes.root}cart/change.js`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            line: item.index,
                            quantity: item.quantity,
                            properties: item.existingProperties
                        }),
                    }).then(() => {
                        i++;
                        updateItemsInOrder();
                    });
                };

                updateItemsInOrder();
            }
        })
        .catch(e => {
            /* silent */
        });
};

// Add despatch information to all cart items before checkout
const addDespatchPropertiesToCart = async () => {
    try {
        const response = await fetch(`${Shopify.routes.root}cart.js`);
        const cart = await response.json();
        
        // Get variant metafields from embedded JSON
        const metafieldsScript = document.querySelector('script[data-variant-metafields]');
        if (!metafieldsScript) {
            console.error('Variant metafields not found');
            return false;
        }
        const variantMetafields = JSON.parse(metafieldsScript.textContent);
        
        // Process each item and add despatch property
        const updates = cart.items.map((item, index) => {
            // Start with existing properties (clone to avoid mutation)
            let properties = {};
            if (item.properties) {
                // Deep clone existing properties
                Object.keys(item.properties).forEach(key => {
                    properties[key] = item.properties[key];
                });
            }
            
            // Calculate and add despatch information
            const isFabric = item.sku.endsWith('+M');
            const despatchSplits = calculateDespatchSplits(item, variantMetafields);
            const despatchProperty = formatDespatchProperty(despatchSplits, isFabric);
            properties['Despatch'] = despatchProperty;

            // Build hidden PO Numbers property
            const poNumbersProperty = despatchSplits
                .filter(split => split.poNumber != null)
                .map(split => `${split.date}: ${split.poNumber}`)
                .join('; ');

            if (poNumbersProperty) {
                properties['_PO Numbers'] = poNumbersProperty;
            }

            // Build hidden PO line ID property
            const poLineIDProperty = despatchSplits
                .filter(split => split.poLineID != null)
                .map(split => `${split.date}: ${split.poLineID}`)
                .join('; ');

            if (poLineIDProperty) {
                properties['_PO Line Id'] = poLineIDProperty;
            }
            
            // Update "Number Of Metres" for cut length products
            if (isFabric)
                properties["Number Of Metres"] = item.quantity / 10 + "m";
            
            return {
                line: index + 1,
                quantity: item.quantity,
                properties: properties
            };
        });
        
        // Update all items sequentially
        for (const update of updates) {
            await fetch(`${Shopify.routes.root}cart/change.js`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(update)
            });
        }
        
        return true;
    } catch (error) {
        console.error('Error adding despatch properties:', error);
        return false;
    }
}

function ajaxBarUpdateCart (event) {
    event.preventDefault();

    let mainProductVariants = document.querySelector(".product__variants");
    if (mainProductVariants && typeof mainProductVariants !== "undefined") {
        mainProductVariants.scrollIntoView({ behavior: "smooth" });

        setTimeout(() => {
            let addToCartButton = document.querySelector(".rhtp-atc-form .add-to-cart-button");
            if (addToCartButton && typeof addToCartButton !== "undefined")
                addToCartButton.click();
        }, 800);
    }
}

function quickAddToCart (event, productId) {
    event.preventDefault();

    event.currentTarget.classList.add("disabled");
    document.body.classList.add("updating-cart");

    let addToCartForm = event.target.closest("form");
    let formVariants = addToCartForm.querySelectorAll(".variant-item");

    // Add in a check for range products where the form is actually a parent container for
    // both the ATC and AJAX form fields. For the main product, this is not the case so the
    // check isn't needed there.
    if (addToCartForm && addToCartForm.hasAttribute("data-product-form")) {
        let formData = addToCartForm.getAttribute("data-product-form");
        let formDataObject = JSON.parse(formData);
        if (formDataObject && formDataObject.hasOwnProperty("speedmode")) {
            if (formDataObject.speedmode == true)
                formVariants = addToCartForm.querySelectorAll(".rhtp-atc-form .variant-item");
        }
    }

    // Check if there are any changes to submit (not just quantities > 0)
    // This allows users to reduce quantities to 0 (remove items)
    let hasChanges = addToCartForm.querySelectorAll(".quantity-box.quantity-changed").length > 0;

    if (!hasChanges) {
        // No changes to submit - re-enable button and return
        event.currentTarget.classList.remove("disabled");
        document.body.classList.remove("updating-cart");
        
        alert('Please add a quantity before adding to cart.');
        return;
    }

    // Check if any variants with quantity have min length = 0
    let hasMinLengthError = false;
    if (formVariants && typeof formVariants !== 'undefined' && formVariants.length > 0) {
        formVariants.forEach(variant => {
            // Calculate total quantity from base + future inputs
            let quantity = 0;
            const baseInput = variant.querySelector('.quantity-input:not(.future-quantity-input)');
            if (baseInput) {
                const isFabric = baseInput.hasAttribute('data-value-actual');
                quantity += isFabric 
                    ? parseInt(baseInput.getAttribute('data-value-actual'), 10) || 0
                    : parseInt(baseInput.value, 10) || 0;
            }
            const futureInputs = variant.querySelectorAll('.future-quantity-input');
            futureInputs.forEach(inp => {
                const isFabric = inp.hasAttribute('data-value-actual');
                quantity += isFabric
                    ? parseInt(inp.getAttribute('data-value-actual'), 10) || 0
                    : parseInt(inp.value, 10) || 0;
            });
            
            if (quantity > 0) {
                // Check all min length inputs for this variant
                const minLengthInputs = variant.querySelectorAll('.min-length-input');
                if (minLengthInputs.length > 0) {
                    minLengthInputs.forEach(minLengthInput => {
                        const minLength = parseFloat(minLengthInput.value.replace('m', '').trim()) || 0;
                        if (minLength === 0) {
                            hasMinLengthError = true;
                        }
                    });
                }
            }
        });
    }

    if (hasMinLengthError) {
        // Show error message and re-enable button
        event.currentTarget.classList.remove("disabled");
        document.body.classList.remove("updating-cart");
        
        alert('Please set a minimum length for all variants with quantities greater than 0.');
        return;
    }

    var addData = {
        "items": []
    };
    var updateData = {
        "updates": {}
    };

    // Consolidate each variant into a single line with despatch properties
    const jobs = [];
    const regularVariants = new Map(); // Track regular (non-preorder) variants by ID
    const preorderVariants = []; // Track preorder variants separately
    
    if (formVariants && typeof formVariants !== 'undefined' && formVariants.length > 0) {
        formVariants.forEach(variant => {
            variant.classList.add('disabled');
            const qBtns = variant.querySelectorAll('.quantity-btn');
            qBtns?.forEach(btn => btn.classList.add('disabled'));
            const input = variant.querySelector('.quantity-input');
            if (!input) return;
            const vId = input.getAttribute('data-variant-id');
            if (!vId) return;
            
            // Only process variants that have changes
            const quantityBox = variant.querySelector('.quantity-box.quantity-changed');
            if (!quantityBox) return;
            
            // Check if this is a preorder variant
            const isPreorder = variant.classList.contains('preorder') && variant.classList.contains('preorder-phantom');
            
            if (isPreorder) {
                // Preorder variants are handled as separate line items
                preorderVariants.push({ variantId: vId, el: variant });
            } else {
                // Regular variants are deduplicated by variant ID
                if (!regularVariants.has(vId)) {
                    regularVariants.set(vId, variant);
                }
            }
        });
        
        // Add regular variants to jobs (one per unique variant ID)
        regularVariants.forEach((element, variantId) => {
            jobs.push({ variantId, el: element, isPreorder: false });
        });
        
        // Add all preorder variants to jobs (each is separate)
        preorderVariants.forEach(item => {
            jobs.push({ ...item, isPreorder: true });
        });
    }

    (async function run() {
        for (const j of jobs) {
            await consolidateVariantToSingleLine(productId, j.variantId, j.el, j.isPreorder);
        }
        scheduleCartCountRefresh();
        scheduleCartSubtotalRefresh();
        setTimeout(() => {
            document.body.classList.remove('updating-cart');
            formVariants?.forEach(variant => {
                variant.classList.remove('disabled');
                const qBtns = variant.querySelectorAll('.quantity-btn');
                qBtns?.forEach(btn => btn.classList.remove('disabled'));
            });
            if (event.currentTarget)
                event.currentTarget.classList.remove('disabled');

            enableButton();
            updateButtonState();
        }, 600);
    })();
}

// After generic add/update calls, reconcile future allocation adjustments that require property targeting.
function processFuturePropertyUpdates(productId) {
    // Gather pending future inputs flagged earlier
    const pending = document.querySelectorAll('.future-quantity-input[data-pending-future-update="true"]');
    if (!pending.length) return;

    // We need the latest cart to map variant+_expected_date to a line key
    fetch(`${Shopify.routes.root}cart.js`)
        .then(r => r.json())
        .then(cart => {
            const tasks = [];
            pending.forEach(input => {
                const variantId = parseInt(input.getAttribute('data-variant-id'),10);
                const expectedDate = input.getAttribute('data-expected-date');
                const newQty = parseInt(input.getAttribute('data-new-quantity'),10);
                const prevQty = parseInt(input.getAttribute('data-previous-quantity'),10);
                if (isNaN(newQty) || newQty === prevQty) return;
                // Find matching line
                let lineIndex = null; // 1-based
                cart.items.forEach((ci, idx) => {
                    if (ci.variant_id === variantId && ci.properties && ci.properties._expected_date === expectedDate) {
                        lineIndex = idx + 1;
                    }
                });
                if (lineIndex !== null) {
                    tasks.push({ line: lineIndex, quantity: newQty, input: input });
                }
            });
            if (!tasks.length) {
                // Clean up pending flags even if no tasks
                pending.forEach(input => {
                    input.removeAttribute('data-pending-future-update');
                    input.removeAttribute('data-new-quantity');
                });
                scheduleCartCountRefresh();
                scheduleCartSubtotalRefresh();
                return;
            }
            // Sequentially process change.js calls to avoid race conditions
            const runTask = (i) => {
                if (i >= tasks.length) {
                    // Clean up pending flags
                    pending.forEach(input => {
                        input.removeAttribute('data-pending-future-update');
                        input.removeAttribute('data-new-quantity');
                        // Update data-value to reflect new quantity
                        const newQty = input.value;
                        input.setAttribute('data-value', newQty);
                    });
                    // Refresh affected UI blocks
                    scheduleCartCountRefresh();
                    scheduleCartSubtotalRefresh();
                    return;
                }
                const t = tasks[i];
                fetch(`${Shopify.routes.root}cart/change.js`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ line: t.line, quantity: t.quantity })
                }).then(() => runTask(i+1)).catch(() => runTask(i+1));
            };
            runTask(0);
        })
        .catch(()=>{});
}

// Map updateData (keyed by variant id) to cart item keys and POST to /cart/update.js
function applyUpdateDataByKey(updateData, productId, callback) {
    if (!updateData || !updateData.updates) { if (typeof callback === 'function') callback(); return; }

    fetch(`${Shopify.routes.root}cart.js`).then(r => r.json()).then(cart => {
        const updatesByKey = {};

        Object.keys(updateData.updates).forEach(k => {
            const variantId = parseInt(k, 10);
            const qty = parseInt(updateData.updates[k], 10) || 0;

            // prefer an in-stock line (no _expected_date) matching this variant
            let match = null;
            for (let i = 0; i < cart.items.length; i++) {
                const ci = cart.items[i];
                if (ci.variant_id === variantId) {
                    if (!ci.properties || !ci.properties._expected_date) {
                        match = ci; break;
                    }
                    if (!match) match = ci; // fallback to any match
                }
            }

            if (match && match.key) {
                updatesByKey[match.key] = qty;
            } else {
                // no existing matching line — fall back to add
                // Use cartApiCall add path for compatibility
                cartApiCall('/cart/add.js', { items: [{ id: variantId, quantity: qty }] }, 'items', productId, true);
            }
        });

        if (Object.keys(updatesByKey).length === 0) {
            if (typeof callback === 'function') callback();
            return;
        }

        // POST to /cart/update.js using item keys
        fetch(`${Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updatesByKey })
        }).then(() => {
            if (typeof callback === 'function') callback();
        }).catch(() => {
            // fallback to legacy cartApiCall if fetch fails
            const fallback = { updates: {} };
            Object.keys(updatesByKey).forEach(k => { fallback.updates[k] = updatesByKey[k]; });
            cartApiCall('/cart/update.js', fallback, 'updates', productId, true, callback);
        });
    }).catch(() => { if (typeof callback === 'function') callback(); });
}

function updateButtonState () {
    // Find all add-to-cart forms on the page
    let forms = document.querySelectorAll(".add-to-cart-form, form[data-product-id]");
    
    forms.forEach(form => {
        let submitButton = form.querySelector(".add-to-cart-button");
        if (!submitButton) return;

        // Check if any quantity has been changed within this form
        let hasChanges = form.querySelectorAll(".quantity-box.quantity-changed").length > 0;
        
        if (hasChanges) {
            submitButton.classList.remove("disabled");
        } else {
            submitButton.classList.add("disabled");
        }
    });
}

// Initialize min length fields on page load based on current quantities
async function initializeMinLengthFields() {
    try {
        // Fetch current cart to get min length properties
        const cart = await fetch(`${Shopify.routes.root}cart.js`).then(r => r.json());
        
        // Find all variant items with rolls or remnants that have quantity
        const variantItems = document.querySelectorAll('.variant-item');
        variantItems.forEach(variantItem => {
            const itemType = variantItem.getAttribute('data-item-type');
            if (itemType !== 'roll' && itemType !== 'remnant') return;
            
            // Get the main quantity input (not future stock)
            const quantityInput = variantItem.querySelector('.variant-item__qty input.quantity-input');
            if (!quantityInput) return;
            
            const variantId = quantityInput.getAttribute('data-variant-id');
            const qty = parseInt(quantityInput.value, 10) || 0;
            
            // Rebuild min length blocks if quantity > 0
            if (qty > 0 && variantId) {
                rebuildMinLengthBlocks(variantId, qty);
                
                // Find the cart item for this variant to get min length properties
                const cartItem = cart.items.find(item => {
                    if (item.variant_id !== parseInt(variantId, 10)) return false;
                    // Skip preorder items
                    if (item.properties && item.properties._preorder === 'true') return false;
                    return true;
                });
                
                if (cartItem && cartItem.properties) {
                    // Wait a tick for the DOM to update, then populate the values
                    setTimeout(() => {
                        const minLengthInputs = variantItem.querySelectorAll('.min-length-input');
                        minLengthInputs.forEach((input, index) => {
                            const rollNumber = index + 1;
                            const propertyKey = `Min Length Roll ${rollNumber}`;
                            const savedValue = cartItem.properties[propertyKey];
                            
                            if (savedValue) {
                                // Set the value (already has 'm' suffix in cart)
                                input.value = savedValue;
                                const numericValue = parseFloat(savedValue.replace('m', '')) || 1;
                                input.setAttribute('data-value', numericValue);
                                input.setAttribute('data-previous-quantity', numericValue);
                            }
                        });
                    }, 50);
                }
            }
        });
    } catch (error) {
        console.error('Error initializing min length fields:', error);
    }
}

function enableButton () {
    let submitButton = document.querySelector(".add-to-cart-button.disabled");
    if (submitButton && typeof submitButton !== "undefined") {
        // Get the relevant button texts depending on the order context
        let emptyText = submitButton.getAttribute("data-new-text");
        let nonEmptyText = submitButton.getAttribute("data-existing-text");


        let quantityBoxes = document.querySelectorAll(".rhtp-atc-form .quantity-box input[name=quantity]");
        let runningQuantity = 0;
        quantityBoxes.forEach(quantityBox => {
            runningQuantity += parseInt(quantityBox.value);
        });

        if (submitButton.children && submitButton.children.length) {
            if (runningQuantity == 0)
                submitButton.children[0].innerHTML = emptyText;
            else
                submitButton.children[0].innerHTML = nonEmptyText;
        }

        submitButton.classList.remove("disabled");
    }
}

var alertShown = false;

var cartApiCall = function (url, data, key, productId, quickMode, callback) {
    var clearDisabledStatus = function (variantId) {
        if (typeof variantId === "undefined" || variantId === null) {
            // Apply changes to all items if variantId is not provided
            $('.variant-item').removeClass('disabled');
            $('.variant-item').find('.quantity-btn').removeClass('disabled');
        } else {
            // Re-enable the variant add to cart buttons
            $('.variant-' + variantId).removeClass('disabled');
            $('.variant-' + variantId).find('.quantity-btn').removeClass('disabled');
        }

        // Remove the loading spinner and reset buttons if the queue is empty
        if (cartItemsQueue.size === 0) {
            $('.variant-item').removeClass('disabled');
            $('.variant-item').find('.quantity-btn').removeClass('disabled');
            $('body').removeClass('updating-cart');
        }

        if (!callback || (callback && typeof callback !== "undefined"))
            enableButton();
    }

    function handleResponse (success = true) {
        for (var dataKey in data[key]) {
            // updateData is not an object, with a key:value pair of variantId and quantity
            variantId = dataKey;
            quantity = data[key][dataKey];
            // addData is an object, with the values passed as JSON being accessible
            if (typeof quantity === 'object') {
                variantId = quantity.id;
                quantity = quantity.quantity;
            }
            // Delete the variant from the queue and re-enable it
            cartItemsQueue.delete(parseInt(variantId));
            setTimeout(() => clearDisabledStatus(variantId), quickMode ? 1000 : 4000);
            // Reload the subtotal and the quantity input

            if (success) {
                let quantityBoxes = document.querySelectorAll(`.add-to-cart-form[data-product-id='${productId}'] .quantity-changed`);
                quantityBoxes.forEach(box => {
                    box.classList.remove('quantity-changed');
                    box.classList.add('quantity-in-cart');

                    let input = box.querySelector('input.quantity-input');
                    if (input) {
                        let currentQty = parseInt(input.value, 10) || 0;
                        input.setAttribute('data-value', currentQty);
                        input.setAttribute('data-previous-quantity', currentQty);
                    }
                });
                updateButtonState();
            }

            // Stock message
            variantStockMessage(variantId, quantity);
        }

        if (!callback) {
            if (alertShown)
                alertShown = false;
        } else if (typeof callback == 'function') {
            callback();
        }
    }

    var params = {
        type: 'POST',
        url: url,
        data: data,
        dataType: 'json',
        success: function(cart) {
            // Refresh the cart icon, cart bar & variant field (debounced)
            scheduleCartCountRefresh();
            scheduleCartSubtotalRefresh();

            handleResponse(true);
        },
        error: function(XMLHttpRequest, textStatus) {
            if (XMLHttpRequest && XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.message) {
                if (!alertShown) {
                    alert("There was a problem adding some of the items you requested.");
                    alertShown = true;
                }
            }

            handleResponse(false);
        }
    };
    jQuery.ajax(params);
}

function rebuildMinLengthBlocks(variantId, qty) {
    console.log(variantId, qty);
    // Find the variant item container
    const variantItem = document.querySelector(`.variant-item.variant-${variantId}`);
    if (!variantItem) return;
    
    // Get the item type - only rebuild for rolls and remnants
    const itemType = variantItem.getAttribute('data-item-type');
    if (itemType !== 'roll' && itemType !== 'remnant') return;

    // Find the label span
    const labelSpan = variantItem.querySelector('.variant-item__min_length:not(.variant-item__qty)');
    
    // Find existing min length blocks (might not exist on first run)
    let allMinLengthBlocks = variantItem.querySelectorAll('.variant-item__qty.variant-item__min_length');
    
    // Extract data attributes from first existing block, or use defaults
    let stock = '0';
    let maxLength = '99';
    if (allMinLengthBlocks.length > 0) {
        const firstInput = allMinLengthBlocks[0].querySelector('.min-length-input');
        if (firstInput) {
            stock = firstInput.getAttribute('data-variant-stock') || '0';
            maxLength = firstInput.getAttribute('max') || '99';
        }
    } else {
        // Try to find from the template-rendered input
        const templateInput = variantItem.querySelector('.min-length-input');
        if (templateInput) {
            stock = templateInput.getAttribute('data-variant-stock') || '0';
            maxLength = templateInput.getAttribute('max') || '99';
        }
    }
    
    const defaultValue = '0';
    
    // Remove all existing dynamically created min length blocks
    allMinLengthBlocks.forEach(block => block.remove());

    // If quantity is 0, hide the label and return
    if (qty <= 0) {
        if (labelSpan) labelSpan.style.display = 'none';
        return;
    }

    // Show the label
    if (labelSpan) labelSpan.style.display = 'inline';

    // Create new min length blocks for each quantity
    let lastInsertedElement = labelSpan;
    for (let i = 1; i <= qty; i++) {
        const block = document.createElement("div");
        block.className = "variant-item__qty variant-item__min_length";
        block.style.display = 'inline';

        block.innerHTML = `
            <span>Roll ${i}</span>
            <div class="quantity-box">
                <span class="quantity-btn min-length-minus icon icon-minus no-ajax">-</span>
                <div class="quantity-input-container">
                    <input 
                        type="text"
                        id="min-length-${variantId}-${i}"
                        data-variant-id="${variantId}"
                        data-variant-stock="${stock}"
                        data-previous-quantity="${defaultValue}"
                        name="min_length"
                        value="${defaultValue}m"
                        data-value="${defaultValue}"
                        max="${maxLength}"
                        maxlength="4"
                        class="quantity-selector min-length-input"
                    >
                </div>
                <span class="quantity-btn min-length-plus icon icon-plus no-ajax">+</span>
            </div>
        `;

        // Insert after the last inserted element to maintain ascending order
        if (lastInsertedElement) {
            lastInsertedElement.insertAdjacentElement('afterend', block);
            lastInsertedElement = block;
        }
        
        // Add event listeners for the buttons (not inline onclick)
        const minusBtn = block.querySelector('.min-length-minus');
        const plusBtn = block.querySelector('.min-length-plus');
        const input = block.querySelector('.min-length-input');
        
        if (minusBtn && input) {
            minusBtn.addEventListener('click', function(e) {
                e.preventDefault();
                updateMinLengthValue(input, -0.1, maxLength);
            });
        }
        
        if (plusBtn && input) {
            plusBtn.addEventListener('click', function(e) {
                e.preventDefault();
                updateMinLengthValue(input, 0.1, maxLength);
            });
        }
        
        if (input) {
            input.addEventListener('change', function(e) {
                validateMinLengthInput(input, maxLength);
            });
        }
    }
}

// Helper function to update min length value
function updateMinLengthValue(input, change, maxLength) {
    let currentValue = input.value.replace('m', '').trim();
    let metres = parseFloat(currentValue) || 0;
    const maxMetres = parseFloat(maxLength) || 99;
    const minMetres = 1;
    
    metres += change;
    
    // Clamp to valid range (minimum 1m when interacting)
    if (metres < minMetres) metres = minMetres;
    if (metres > maxMetres) metres = maxMetres;
    
    // Round to 1 decimal place
    metres = Math.round(metres * 10) / 10;
    
    // Update display value (always show with 'm' suffix)
    input.value = metres.toFixed(1) + 'm';
    input.setAttribute('data-value', metres);
    
    // Mark as changed
    const quantityBox = input.closest('.quantity-box');
    if (quantityBox) {
        quantityBox.classList.add('quantity-changed');
    }
    
    // Update button state
    updateButtonState();
}

// Helper function to validate min length input
function validateMinLengthInput(input, maxLength) {
    let enteredValue = input.value.replace('m', '').trim();
    let metres = parseFloat(enteredValue);
    const maxMetres = parseFloat(maxLength) || 99;
    const minMetres = 1;
    
    // If no value or invalid, return to 0
    if (isNaN(metres) || metres === 0) {
        input.value = '0m';
        input.setAttribute('data-value', '0');
        return;
    }
    
    // Clamp to valid range
    if (metres > maxMetres) {
        metres = maxMetres;
    }
    
    // Ensure minimum 1m when a value is entered
    if (metres < minMetres) metres = minMetres;
    
    // Round to 1 decimal place
    metres = Math.round(metres * 10) / 10;
    
    // Update display value (always show with 'm' suffix)
    input.value = metres.toFixed(1) + 'm';
    input.setAttribute('data-value', metres);
    
    // Mark as changed
    const quantityBox = input.closest('.quantity-box');
    if (quantityBox) {
        quantityBox.classList.add('quantity-changed');
    }
    
    updateButtonState();
}


function updateAjaxCart(
    event, productId, variantId, variantStock, variantInventoryQuantity, isFabricForm = false
) {
    var e = event.target;
    let isCutLengthFabricInput = isFabricForm;
    let isMinLengthFabricInput = $(e).closest('.variant-item__min_length').length > 0;
    
    // Determine if this is a plus or minus button
    const isPlus = $(e).hasClass('icon-plus') || $(e).closest('.quantity-btn').hasClass('icon-plus');
    const isMinus = $(e).hasClass('icon-minus') || $(e).closest('.quantity-btn').hasClass('icon-minus');
    
    // Find the input field
    let input;
    if (isMinLengthFabricInput) {
        // Min length inputs are siblings within the same quantity-box
        input = $(e).closest('.quantity-box').find('.min-length-input')[0];
    } else {
        // Regular quantity inputs
        input = $(e).closest('.quantity-box').find('.quantity-input')[0];
    }
    
    if (!input) return;
    
    // Get current values
    const minAttr = parseInt(input.getAttribute('min'), 10) || 0;
    const maxAttr = parseInt(input.getAttribute('max'), 10) || 9999;
    
    // Handle cut length fabric (0.1m increments, stored as units × 10)
    if (isCutLengthFabricInput) {
        let actual = parseInt(input.getAttribute('data-value-actual'), 10) || 0;
        const minActual = 10; // 1.0m minimum
        const maxActual = maxAttr * 10; // Max is in metres, convert to units
        const isPhantomPreorder = input.getAttribute('data-preorder-type') === 'phantom';
        const isMadeToOrder = (maxAttr === 9999 && !isPhantomPreorder); // 9999m for made-to-order, but not phantom
        
        if (isPlus) {
            if (actual === 0) {
                actual = minActual; // Jump to 1.0m
            } else if (actual < maxActual) {
                actual += 1; // Add 0.1m
            }
        } else if (isMinus) {
            if (actual <= minActual) {
                actual = 0; // Go to zero
            } else {
                actual -= 1; // Subtract 0.1m
            }
        }
        
        // Update data-value-actual attribute
        input.setAttribute('data-value-actual', actual);
        input.setAttribute('data-value', actual);
        
        // Update display value
        let displayValue;
        if (actual === 0) {
            displayValue = '0';
        // } else if (isMadeToOrder) {
        //     displayValue = actual; // Show raw units for made-to-order
        } else {
            displayValue = (actual / 10).toFixed(1) + 'm'; // Show as metres with 'm' suffix
        }
        
        input.value = displayValue;
    }
    // Handle min length inputs (work like cut fabric but just update the field)
    else if (isMinLengthFabricInput) {
        let currentValue = input.value.replace('m', '').trim();
        let metres = parseFloat(currentValue) || 0;
        const minMetres = 0;
        const maxMetres = parseFloat(input.getAttribute('max')) || 99;
        
        if (isPlus) {
            if (metres === 0)
                metres = 1; // Jump to 1m
            else if (metres < maxMetres)
                metres += 0.1; // Add 0.1m
        } else if (isMinus) {
            if (metres <= 1)
                metres = 0; // Go to zero
            else
                metres -= 0.1; // Subtract 0.1m
        }
        
        // Round to 1 decimal place
        metres = Math.round(metres * 10) / 10;
        
        // Update display value
        input.value = metres === 0 ? '0' : metres.toFixed(1) + 'm';
        input.setAttribute('data-value', metres);
    }
    // Handle regular quantity inputs (whole numbers)
    else {
        let qty = parseInt(input.value, 10) || 0;
        
        if (isPlus) {
            if (qty < maxAttr) {
                qty += 1;
            } else {
                // At max - show feedback
                showQuantityFeedback(input.closest('.quantity-box'), 'Max ' + maxAttr + ' available');
            }
        } else if (isMinus) {
            if (qty > 0) {
                qty -= 1;
            }
        }
        
        // Update input value
        input.value = qty;
        input.setAttribute('data-value', qty);
        
        // Rebuild min length blocks based on new quantity
        const variant = input.closest('.variant-item');
        if (variant) {
            const variantId = input.getAttribute('data-variant-id');
            if (variantId) {
                rebuildMinLengthBlocks(variantId, qty);
            }
        }
    }
    
    // Mark as changed if not already in cart or value differs from previous
    const previousQty = input.getAttribute('data-previous-quantity') || '0';
    const currentDisplayValue = input.value;
    const quantityBox = input.closest('.quantity-box');
    
    if (quantityBox) {
        // Check if value has changed from what's in cart
        let hasChanged = false;
        if (isCutLengthFabricInput) {
            const actual = parseInt(input.getAttribute('data-value-actual'), 10) || 0;
            hasChanged = actual != parseInt(previousQty, 10);
        } else {
            const currentValue = isMinLengthFabricInput ? 
                parseFloat(currentDisplayValue.replace('m', '')) : 
                parseInt(currentDisplayValue, 10);
            hasChanged = currentValue != parseFloat(previousQty);
        }
        
        if (hasChanged) {
            quantityBox.classList.add('quantity-changed');
            quantityBox.classList.remove('quantity-in-cart');
        } else {
            quantityBox.classList.remove('quantity-changed');
            const currentValue = isMinLengthFabricInput ? 
                parseFloat(currentDisplayValue.replace('m', '')) : 
                parseInt(currentDisplayValue, 10);
            if (currentValue > 0)
                quantityBox.classList.add('quantity-in-cart');
        }
        updateButtonState();
    }
}

function textInputUpdateCart (event, productId) {
    const input = event.target;
    
    // Determine input type
    const isCutLengthFabricInput = input.classList.contains("quantity-input") && input.hasAttribute("data-value-actual");
    const isMinLengthFabricInput = input.classList.contains("min-length-input");
    
    const previousQuantity = input.getAttribute('data-previous-quantity') || '0';
    let enteredValue = input.value;
    
    // Handle cut length fabric (0.1m increments with data-value-actual)
    if (isCutLengthFabricInput) {
        // Remove 'm' suffix and parse
        let metres = parseFloat(enteredValue.replace('m', '').trim()) || 0;
        
        // Get constraints
        const minMetres = 1.0;
        const maxAttr = parseInt(input.getAttribute('max'), 10) || 9999;
        const maxMetres = maxAttr; // Max is already in metres
        const isPhantomPreorder = input.getAttribute('data-preorder-type') === 'phantom';
        const isMadeToOrder = (maxAttr === 9999 && !isPhantomPreorder);
        
        // Clamp to valid range
        if (metres > 0 && metres < minMetres) {
            metres = minMetres; // Enforce minimum
        } else if (metres > maxMetres) {
            metres = maxMetres;
            showQuantityFeedback(input.closest('.quantity-box'), 'Max ' + maxMetres + 'm available');
        }
        
        // Round to 1 decimal place
        metres = Math.round(metres * 10) / 10;
        
        // Convert to units (× 10)
        const units = Math.round(metres * 10);
        
        // Update attributes
        input.setAttribute('data-value-actual', units);
        input.setAttribute('data-value', units);
        
        // Update display value
        if (units === 0)
            input.value = '0';
        // else if (isMadeToOrder)
        //     input.value = units; // Show raw units for made-to-order
        else
            input.value = metres.toFixed(1) + 'm';
    }
    // Handle min length inputs (0.1m increments, no cart update)
    else if (isMinLengthFabricInput) {
        // Remove 'm' suffix and parse
        let metres = parseFloat(enteredValue.replace('m', '').trim()) || 0;
        
        // Get constraints
        const minMetres = 0;
        const maxMetres = parseFloat(input.getAttribute('max')) || 99;
        
        // Clamp to max if exceeded
        if (metres > maxMetres)
            metres = maxMetres;
        
        // Round to 1 decimal place
        metres = Math.round(metres * 10) / 10;
        
        // Update display value
        input.value = metres === 0 ? '0' : metres.toFixed(1) + 'm';
        input.setAttribute('data-value', metres);
    }
    // Handle regular quantity inputs (whole numbers)
    else {
        let qty = parseInt(enteredValue, 10) || 0;
        
        // Get constraints
        const maxAttr = parseInt(input.getAttribute('max'), 10);
        
        // Clamp to max if present
        if (!isNaN(maxAttr) && qty > maxAttr) {
            qty = maxAttr;
            showQuantityFeedback(input.closest('.quantity-box'), 'Max ' + maxAttr + ' available');
        }
        
        // Ensure non-negative
        if (qty < 0) qty = 0;
        
        // Update value
        input.value = qty;
        input.setAttribute('data-value', qty);
        
        // Rebuild min length blocks based on new quantity
        const variant = input.closest('.variant-item');
        if (variant) {
            const variantId = input.getAttribute('data-variant-id');
            if (variantId) {
                rebuildMinLengthBlocks(variantId, qty);
            }
        }
        
        // Auto-expand future stock if user reached or exceeded max
        if (!isNaN(maxAttr) && qty >= maxAttr) {
            if (!input.classList.contains('future-quantity-input')) {
                const variantItem = input.closest('.variant-item');
                if (variantItem) {
                    expandFutureStock(variantItem);
                }
            }
        }
    }
    
    // Mark as changed if value differs from what's in cart
    const quantityBox = input.closest('.quantity-box');
    if (quantityBox) {
        let hasChanged = false;
        
        if (isCutLengthFabricInput) {
            const actual = parseInt(input.getAttribute('data-value-actual'), 10) || 0;
            hasChanged = actual != parseInt(previousQuantity, 10);
        } else if (isMinLengthFabricInput) {
            const currentMetres = parseFloat(input.value.replace('m', '')) || 0;
            hasChanged = currentMetres != parseFloat(previousQuantity);
        } else {
            const currentQty = parseInt(input.value, 10) || 0;
            hasChanged = currentQty != parseInt(previousQuantity, 10);
        }
        
        if (hasChanged) {
            quantityBox.classList.add('quantity-changed');
            quantityBox.classList.remove('quantity-in-cart');
        } else {
            quantityBox.classList.remove('quantity-changed');
            let currentValue;
            if (isCutLengthFabricInput) {
                currentValue = parseInt(input.getAttribute('data-value-actual'), 10) || 0;
            } else if (isMinLengthFabricInput) {
                currentValue = parseFloat(input.value.replace('m', '')) || 0;
            } else {
                currentValue = parseInt(input.value, 10) || 0;
            }
            if (currentValue > 0) {
                quantityBox.classList.add('quantity-in-cart');
            }
        }

        updateButtonState();
    }
}

function variantStockMessage(variantId, variantQuantity) {
    var variantStock = $('.variant-'+ variantId).find('.stock-level').attr('data-value');
    var stockExceededMessage = $('.variant-'+ variantId).find('.stock-message.stock-exceeded');
    var variantCartonQuantity = $('.variant-'+ variantId).find('.carton-quantity').attr('data-value');
    var cartonQuantityMessage = $('.variant-'+ variantId).find('.stock-message.carton-quantity');
    var cartonQuantityMessageElement = $('.variant-'+ variantId).find('.stock-message.carton-quantity .totalQuantity');

    // Clean up quantity & stock values
    variantQuantity = parseInt(variantQuantity);
    variantStock = parseInt(variantStock);

    // show stock message if qty is greater than stock
    if (variantQuantity > variantStock) {
        var variantDispatch = variantStock;
        var variantBackorder = variantQuantity - variantStock;
        stockExceededMessage.addClass('show-stock-message');
    } else if (variantQuantity <= variantStock) {
        var variantDispatch = variantQuantity;
        var variantBackorder = 0;
        stockExceededMessage.removeClass('show-stock-message');
    }

    if (variantQuantity > 0)
        cartonQuantityMessageElement.text(variantQuantity);

    // show carton quantity message
    if (variantQuantity >= variantCartonQuantity)
        cartonQuantityMessage.addClass('show-stock-message');
    else if (variantQuantity < variantCartonQuantity)
        cartonQuantityMessage.removeClass('show-stock-message');

    // Update stock exceeded stock message element
    $(".variant-"+ variantId +" .stock-message.stock-exceeded" ).load(location.href+" .variant-"+ variantId +" .stock-message.stock-exceeded > *","");
}

// Get the collection filter container
const filterContainer = document.getElementById('collection-filter');

// Build filters for collection pages
function buildCollectionFilters() {
    if (filterContainer) {
        // Get filter data attributes from variants
        const getColourFilterItems = document.querySelectorAll('[data-filter-colour]');
        const getSizeFilterItems = document.querySelectorAll('[data-filter-size]');
        const getFillingFilterItems = document.querySelectorAll('[data-filter-filling]');
        const getMaterialFilterItems = document.querySelectorAll('[data-filter-material]');

        // Create empty filter arrays
        var colourFilterArray = [];
        var sizeFilterArray = [];
        var fillingFilterArray = [];
        var materialFilterArray = [];

        // Add filter attributes to array
        [...getColourFilterItems].forEach(colourItem => colourFilterArray.push(colourItem.getAttribute('data-filter-colour')));
        [...getSizeFilterItems].forEach(sizeItem => sizeFilterArray.push(sizeItem.getAttribute('data-filter-size')));
        [...getFillingFilterItems].forEach(fillingItem => fillingFilterArray.push(fillingItem.getAttribute('data-filter-filling')));
        [...getMaterialFilterItems].forEach(materialItem => materialFilterArray.push(materialItem.getAttribute('data-filter-material')));

        // Create filter to remove duplicates from array
        const distinct = (value, index, self) => {
            return self.indexOf(value) === index
        }

        // Create distinct filter arrays
        var colours = colourFilterArray.filter(distinct);
        var sizes = sizeFilterArray.filter(distinct);
        var fillings = fillingFilterArray.filter(distinct);
        var materials = materialFilterArray.filter(distinct);
        var columns = 0;

        // Build colours list
        var hasColour = true;
        if (colours.length == 1) {
            colours.map(function(string){
                if (string.length == 0) {
                    hasColour = false;
                }
            })
        }

        if (hasColour == true) {
            var colourFilterHTML = '<div class="filter-col filter-colour" data-filter-type="colour">';
            colourFilterHTML += '<h4>Colour</h4>';
            for (colour in colours) {
                var hex = document.querySelector('[data-filter-options-colour="' + `${colours[colour]}` + '"]').getAttribute('data-filter-hex-colour');
                hex = (hex == '0' ? '000000' : hex);

                if (colours[colour].trim().length > 0)
                    colourFilterHTML += '<div class="input-wrapper"><input type="checkbox" id="' + `${colours[colour]}` + '" class="filter-item" name="' + `${colours[colour]}` + '" value="' + `${colours[colour]}` + '" data-filter-colour="' + `${colours[colour]}` + '"><label for="' + `${colours[colour]}` + '"> <span class="hex-filter" style="background-color: #'+hex.trim()+';">&nbsp;</span> ' + `${colours[colour]}` + '</label></div>';
            }
            colourFilterHTML += '</div>';
            filterContainer.insertAdjacentHTML('beforeend', colourFilterHTML);
            columns++;
        }

        // Build sizes list
        var hasSize = true;
        if (sizes.length == 1) {
            sizes.map(function(string){
                if (string.length == 0) {
                    hasSize = false;
                }
            })
        }

        if (hasSize == true) {
            var sizeFilterHTML = '<div class="filter-col filter-size" data-filter-type="size">';
            sizeFilterHTML += '<h4>Size</h4>';
            for (size in sizes) {
                if (sizes[size].trim().length > 0)
                    sizeFilterHTML += '<div class="input-wrapper"><input type="checkbox" id="' + `${sizes[size]}` + '" class="filter-item" name="' + `${sizes[size]}` + '" value="' + `${sizes[size]}` + '" data-filter-size="' + `${sizes[size]}` + '"><label for="' + `${sizes[size]}` + '">' + `${sizes[size]}` + '</label></div>';
            }
            sizeFilterHTML += '</div>';
            filterContainer.insertAdjacentHTML('beforeend', sizeFilterHTML);
            columns++;
        }

        // Build fillings list
        var hasFilling = true;
        if (fillings.length == 1) {
            fillings.map(function(string){
                if (string.length == 0) {
                    hasFilling = false;
                }
            })
        }

        if (hasFilling == true) {
            var fillingFilterHTML = '<div class="filter-col filter-filling" data-filter-type="filling">';
            fillingFilterHTML += '<h4>Filling</h4>';
            for (filling in fillings) {
                if (fillings[filling].trim().length > 0)
                    fillingFilterHTML += '<div class="input-wrapper"><input type="checkbox" id="' + `${fillings[filling]}` + '" class="filter-item" name="' + `${fillings[filling]}` + '" value="' + `${fillings[filling]}` + '" data-filter-filling="' + `${fillings[filling]}` + '"><label for="' + `${fillings[filling]}` + '">' + `${fillings[filling]}` + '</label></div>';
            }
            fillingFilterHTML += '</div>';
            filterContainer.insertAdjacentHTML('beforeend', fillingFilterHTML);
            columns++;
        }

        // Build materials list
        var hasMaterial = true;
        if (materials.length == 1) {
            materials.map(function(string){
                if (string.length == 0) {
                  hasMaterial = false;
                }
            })
        }

        if (hasMaterial == true) {
            var materialFilterHTML = '<div class="filter-col filter-material" data-filter-type="material">';
            materialFilterHTML += '<h4>Material</h4>';
            for (material in materials) {
                if (materials[material].trim().length > 0)
                    materialFilterHTML += '<div class="input-wrapper"><input type="checkbox" id="' + `${materials[material]}` + '" class="filter-item" name="' + `${materials[material]}` + '" value="' + `${materials[material]}` + '" data-filter-material="' + `${materials[material]}` + '"><label for="' + `${materials[material]}` + '">' + `${materials[material]}` + '</label></div>';
            }
            materialFilterHTML += '</div>';
            filterContainer.insertAdjacentHTML('beforeend', materialFilterHTML);
            columns++;
        }

        //Create hidden no results element for when no products match filters
        var noResultsElement = document.createElement('p');
        noResultsElement.classList.add('filter-no-results');
        noResultsElement.innerText = "Sorry, there are no results to display.";
        noResultsElement.style.display = "none";
        var productLoopElement = document.querySelector('#product-loop');
        if (productLoopElement !== null)
            productLoopElement.parentNode.insertBefore(noResultsElement,productLoopElement);

        // TODO: Add column width based on number of cols
        var columnEl = document.getElementsByClassName('filter-col');
        var columnWidth = 100 / columns;
    }
}
window.onload = buildCollectionFilters;

// ================= Current Selections Panel (scoped to product) =================
// Supports multiple instances: use button class `.toggle-currentselections` and panel class `.current-selections`
document.addEventListener('DOMContentLoaded', function() {
    // Initialize button state - disable button until changes are made
    updateButtonState();
    
    // Initialize min length fields based on current quantities
    initializeMinLengthFields();
    
    // Prevent Enter key in quantity inputs from submitting the form
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' && (e.target.classList.contains('quantity-input') || e.target.classList.contains('min-length-input'))) {
            e.preventDefault();
            e.target.blur(); // Optional: remove focus from input
        }
    });
    
    // Registry for per-product refresh functions
    window._rhtpCurrentSelections = window._rhtpCurrentSelections || { refreshers: {}, updaters: {} };

    const panels = document.querySelectorAll('.current-selections[data-product-id]');
    panels.forEach(panel => {
        const productId = panel.getAttribute('data-product-id');
        if (!productId) return;

        // Try to find the matching toggle button by data attribute or inside the same form
        let toggleBtn = document.querySelector(`.toggle-currentselections[data-product-id='${productId}']`);
        if (!toggleBtn) toggleBtn = panel.closest('.add-to-cart-form')?.querySelector('.toggle-currentselections');
        if (!toggleBtn) toggleBtn = document.querySelector(`.add-to-cart-form[data-product-id='${productId}'] .toggle-currentselections`);
        if (!toggleBtn) return;

        // Avoid double-binding
        if (toggleBtn.dataset && toggleBtn.dataset.listenerAdded === 'true') return;
        if (toggleBtn.dataset) toggleBtn.dataset.listenerAdded = 'true';

        function renderSelections(selections) {
            const ul = panel.querySelector('.current-selections__list');
            if (!ul) return;
            ul.innerHTML = '';
            if (!selections || !selections.length) {
                const li = document.createElement('li');
                li.className = 'current-selections__empty';
                li.textContent = 'No selections yet.';
                ul.appendChild(li);
                return;
            }
            selections.forEach(sel => {
                const li = document.createElement('li');
                const parts = [];
                parts.push(sel.qty + ' x');
                if (sel.variant) parts.push(sel.variant);
                if (sel.type) parts.push('(' + sel.type + (sel.date ? ' – ' + sel.date : '') + ')');
                li.textContent = parts.join(' ');
                ul.appendChild(li);
            });
        }

        function collectSelections() {
            const form = document.querySelector(`.add-to-cart-form[data-product-id='${productId}']`);
            if (!form) return [];
            const variants = form.querySelectorAll('.variant-item');
            const list = [];
            variants.forEach(v => {
                const labelEl = v.querySelector('.label-title');
                const variantName = labelEl ? labelEl.textContent.trim() : 'Variant';
                const baseInput = v.querySelector('.variant-item__qty input.quantity-input:not(.future-quantity-input)');
                if (baseInput) {
                    const qty = parseInt(baseInput.value, 10) || 0;
                    if (qty > 0) list.push({ qty, variant: variantName, type: 'In stock' });
                }
                v.querySelectorAll('.future-quantity-input').forEach(fi => {
                    const fqty = parseInt(fi.value, 10) || 0;
                    if (fqty > 0) list.push({ qty: fqty, variant: variantName, type: 'Future', date: fi.getAttribute('data-expected-date') });
                });
            });
            return list;
        }

        function refreshCurrentSelections() {
            const selections = collectSelections();
            renderSelections(selections);
        }

        // Expose per-product hooks
        window._rhtpCurrentSelections.refreshers[productId] = refreshCurrentSelections;
        window._rhtpCurrentSelections.updaters[productId] = function(selections) { renderSelections(selections); };

        // Initial populate
        refreshCurrentSelections();

        // Toggle behaviour
        toggleBtn.addEventListener('click', function(){
            const expanded = this.getAttribute('aria-expanded') === 'true';
            const newState = !expanded;
            this.setAttribute('aria-expanded', String(newState));
            if (newState) {
                panel.hidden = false;
                panel.setAttribute('aria-hidden', 'false');
                refreshCurrentSelections();
            } else {
                panel.hidden = true;
                panel.setAttribute('aria-hidden', 'true');
            }
        });

        // Scoped live updates: listen to changes within the product form only
        const form = document.querySelector(`.add-to-cart-form[data-product-id='${productId}']`);
        if (form) {
            form.addEventListener('input', function(e){
                if (panel.hidden) return;
                if (!e.target.classList) return;
                if (e.target.classList.contains('quantity-input')) refreshCurrentSelections();
            });
            form.addEventListener('click', function(e){
                if (panel.hidden) return;
                const btn = e.target.closest('.quantity-btn');
                if (btn) setTimeout(refreshCurrentSelections, 0);
            });
        }
    });

    // Convenience: refresh all instances
    window.refreshAllCurrentSelections = function() {
        Object.values(window._rhtpCurrentSelections.refreshers).forEach(fn => { try { fn(); } catch(e){} });
    };
});
// ===============================================================================

// Real-time clamp & feedback while typing (before blur/change)
document.addEventListener('input', function(e) {
    if (!e.target.classList || !e.target.classList.contains('quantity-input')) return;
    if (e.target.classList.contains('fabric-input')) return; // fabric handled separately
    const maxAttr = parseInt(e.target.getAttribute('max'), 10);
    if (isNaN(maxAttr)) return; // nothing to enforce
    // Allow user to clear field temporarily (don't show/hide message until user re-enters)
    if (e.target.value === '') { clearQuantityFeedback(e.target.closest('.quantity-box')); return; }

    let val = parseInt(e.target.value.replace(/[^0-9]/g,''), 10);
    if (isNaN(val)) val = 0;

    if (val > maxAttr) {
        // Clamp and show persistent message
        val = maxAttr;
        e.target.value = maxAttr;
        showQuantityFeedback(e.target.closest('.quantity-box'), 'Only ' + maxAttr + ' available', 0); // duration 0 = persistent
    } else {
        // At or below max -> ensure message cleared
        clearQuantityFeedback(e.target.closest('.quantity-box'));
    }
});

function removeFilterStylesheet() {
    var filterStyleSheet = document.querySelector('#filter-stylesheet');
    if (filterStyleSheet !== null)
        filterStyleSheet.remove();
}

// Show / hide products based on selected filter checkboxes
function filterCollectionProducts(event){
    var filterCols = document.querySelectorAll('#collection-filter > .filter-col');

    if (filterCols.length === 0) {
        removeFilterStylesheet();
        return;
    }

    var filterValues = {};

    //Build a list of all the selected filters
    for (let i = 0; i < filterCols.length; i++) {
        var filters = [];
        var filterType = filterCols[i].getAttribute('data-filter-type');
        var filterInputs = filterCols[i].querySelectorAll('[type="checkbox"]:checked');
        for (var c = 0; c < filterInputs.length; c++)
            filters.push(filterInputs[c].value);
        filterValues[filterType] = filters;
    }

    if (filterValues.length > 0) {
        removeFilterStylesheet();
        return;
    }

    //Get the list with the most selected filters
    var filterListWithMostSelectedKey = '';
    var currentHighestFilterListCount = 0;
    for (var i = 0; i < Object.keys(filterValues).length; i++) {
        var thisKey = Object.keys(filterValues)[i];
        if (filterValues[thisKey].length > currentHighestFilterListCount) {
            filterListWithMostSelectedKey = thisKey;
            currentHighestFilterListCount = filterValues[thisKey].length;
        }
    }

    //Lets build the js document selector.
    var productsToShowSelector = [];
    var tmpFilterObject = JSON.parse(JSON.stringify(filterValues));
    delete tmpFilterObject[filterListWithMostSelectedKey];
    var otherProductFiltersKeys = Object.keys(tmpFilterObject);

    if (typeof filterValues[filterListWithMostSelectedKey] !== 'undefined') {
        for (var i = 0; i < filterValues[filterListWithMostSelectedKey].length; i++) {
            var thisFilterValue = filterValues[filterListWithMostSelectedKey][i];
            var thisQueries = ["#product-loop .product-index[data-filter-options-"+ filterListWithMostSelectedKey +"*='"+thisFilterValue+"']"];
            for (var f = 0; f < otherProductFiltersKeys.length; f++) {
                let thisFilterKey = otherProductFiltersKeys[f];
                var tmpQuery = JSON.parse(JSON.stringify(thisQueries));
                var newQuery = [];
                if (filterValues[thisFilterKey].length > 0) {
                    for (var fk = 0; fk < filterValues[thisFilterKey].length; fk++) {
                        var newThisQueries = [];
                        for (var q = 0; q < tmpQuery.length; q++) {
                            let thisQuery = tmpQuery[q];
                            thisQuery += "[data-filter-options-"+ thisFilterKey +"*='"+filterValues[thisFilterKey][fk]+"']";
                            newThisQueries.push(thisQuery);
                        }
                        newQuery = newQuery.concat(newThisQueries);
                    }
                    thisQueries = JSON.parse(JSON.stringify(newQuery));
                }
            }
            productsToShowSelector = productsToShowSelector.concat(thisQueries);
        }
    }

    //Add stylesheet

    var filterStyleSheet = document.querySelector('#filter-stylesheet');
    if (filterStyleSheet == null) {
        filterStyleSheet = document.createElement("style");
        filterStyleSheet.setAttribute("id","filter-stylesheet");
        filterStyleSheet.setAttribute("type","text/css");
        document.querySelector('body').appendChild(filterStyleSheet);
    }

    var filterCss = "";
    if (productsToShowSelector.length > 0) {
        filterCss += "#product-loop .product-index {display: none !important;}";
        filterCss += productsToShowSelector.join(",") + " { display: flex !important; }";
    }

    //See if there is any products to show
    if (productsToShowSelector.length > 0) {
        var productsToShow = document.querySelector(productsToShowSelector.join(","));
        if (productsToShow === null)
            filterCss += ".filter-no-results {display: block !important;}";
    }

    filterStyleSheet.innerText = filterCss;
}

if (filterContainer) {
    filterContainer.addEventListener('click', filterCollectionProducts);
}

// Collection images slider

$(document).ready(function() {
    $('.js-collection-range').each(function() {
        var thisEl = $(this);
        var productID = thisEl.attr('data-product-id');
        var collectionMain = '.js-collection-range-' + productID;
        var collectionNav = '.js-collection-range-nav-' + productID;

        var $mainCarousel = $(collectionMain).flickity({
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            imagesLoaded: true
        });

        var $navCarousel = $(collectionNav).flickity({
            asNavFor: collectionMain,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            cellAlign: 'left',
            wrapAround: true,
            groupCells: false,
            autoPlay: false,
            draggable: '>1',
            freeScroll: true
        });

        // Change the thumbnail track to match the current item
        $mainCarousel.on('change.flickity', function(event, index) {
            $navCarousel.flickity('select', index);
        });

        // Change the current item to match the selected thumbnail track
        $navCarousel.on('staticClick.flickity', function(event, pointer, cellElement, cellIndex) {
            if (cellElement) {
                $mainCarousel.flickity('select', cellIndex);
            }
        });
    });
});

// Collections accordion toggle
$(document).ready(function() {
    $(".more-info").click(function(){
        var productID = $(this).attr('data-product-id');
        $(".shopify-section-product-accordion[data-product-id=" + productID + "]").toggle();
        $(this).text(function(i, text){
            return text === "More Info" ? "Less Info" : "More Info";
        })
    });
});

// Product page snippet accordion
let productAccordion = $(".product-accordion .accordion");
$(productAccordion).find("button").on("click", function (event) {
    event.stopPropagation();

    let accordion = $(this).closest(".accordion");

    $(productAccordion).not(accordion).removeClass("accordion--open").children("div").slideUp();
    $(productAccordion).not(accordion).find("button i").removeClass("fa-times").addClass("fa-plus");

    if (accordion.hasClass("accordion--open")) {
        accordion.removeClass("accordion--open");
        accordion.children("div").slideUp();
        accordion.find("button i").removeClass("fa-times").addClass("fa-plus");
    } else {
        accordion.addClass("accordion--open");
        accordion.children("div").slideDown();
        accordion.find("button i").toggleClass("fa-plus fa-times");
    }
});

window.termsAndConditions = function() {
    var basketCheckbox = document.querySelector("input[name=basket-tc]");

    if (basketCheckbox.checked) {
        $.fancybox.open($('#tc-content'), {
            // touch: false,
            smallBtn: false,
            toolbar: false,
            clickSlide: false,
        });
    }
}

// Basket T&Cs
var basketCheckbox = document.querySelector("input[name=basket-tc]");

if (basketCheckbox)
    basketCheckbox.addEventListener('change', window.termsAndConditions);

// Function to control adding the gps:yes tag to the customer when the 'Growth Partner' checkbox is checked

document.addEventListener("DOMContentLoaded", function() {
    const gpsCheckbox = document.getElementById("gps");
    const gpsTagInput = document.getElementById("gps-tag");

    // When the GPS checkbox is changed, update the hidden input which controls the adding/removing of the tag
    if (gpsCheckbox && gpsTagInput) {
        gpsCheckbox.addEventListener("change", function() {
            // If the GPS checkbox is disabled, uncheck the tag input.
            gpsTagInput.disabled = !this.checked;
        });
    }
});

// Expand mobile menu third sub-menu and hide accordion
$('.mobile-menu').on('click', '.menu-content__list > li[data-menu-swipe-toggle]', function(){
    setTimeout(function(){
        var expand = $('.mobile-menu .menu-content__list > li:not(.is-flex):not(.mob-view-all)')[0];
        $(expand).children('ul').css('display', 'block');
        $(expand).children('span').css('display', 'none');
    },0);
});

// Show price settings menu element
const showPriceSettings = document.getElementById('show-price-settings');
const hidePriceSettings = document.getElementById('hide-price-settings');

if (showPriceSettings) {
    showPriceSettings.addEventListener('click', togglePriceSettings);
}
if (hidePriceSettings) {
    hidePriceSettings.addEventListener('click', togglePriceSettings);
}

$(document).on("click", function(event) {
    // Ensure that the drawer is already open
    if ($('body').hasClass("js-drawer-open-right-price")) {
        var drawer = document.querySelector("#price-settings");

        // Ensure that the user is not clicking anywhere inside the drawer
        if (drawer && !drawer.contains(event.target) && event.target !== $('#PriceSettingsOpenButton')[0]) {
            $('body').toggleClass("js-drawer-open-right-price");
            $('#price-settings').toggleClass('show-price-settings');
        }
    }
})

function togglePriceSettings() {
    var priceSettingsEl = $('#price-settings');
    const main =  $('.site-wrap');
    const body =  $('body');

    priceSettingsEl.toggleClass('show-price-settings');
    main.toggleClass("is-transitioning");
    body.toggleClass("js-drawer-open-right-price");
}

function applyPriceSettings () {
    var priceEl = $('.pricing');
    var priceUnitEl = $('.pricing-unit');
    var getToggleStatus = $('.price-toggle input:checked').val();
    var getMultiplier = $('#price-multiplier').val();
    var usesSpeedCart = true;
    var searchesFabricsOnly = $('.search-type-toggle input:checked').val();

    var quickForm = $('.rhtp-atc-form');
    var ajaxForm = $('.rhtp-ajax-form');
    var searchBar = $('#search-bar');
    var header = document.querySelector('#shopify-section-header');

    // Handle quick form and AJAX form swap
    if (quickForm.length > 0 && ajaxForm.length > 0) {
        if (usesSpeedCart === true || usesSpeedCart === "true" || usesSpeedCart === 1) {
            quickForm.removeClass("visually-hidden");
            ajaxForm.addClass("visually-hidden");
        } else {
            quickForm.addClass("visually-hidden");
            ajaxForm.removeClass("visually-hidden");
        }
    }

    function updateHeaderHeight() { // Update the header height dynamically when opening the search bar
        if (searchBar.classList.contains('search-bar--open')) {
            header.style.height = '214px';
        } else {
            header.style.height = "134px";
        }
    }

    if (searchBar && searchBar.length > 0) {
        document.querySelector('#toggleSearchBarButton').addEventListener('click', function() {
            if (searchBar.classList.contains('search-bar--open')) {
                // Close the search bar
                searchBar.classList.remove('search-bar--open');
                searchBar.style.maxHeight = '0';
                searchBar.style.display = 'none';
                updateHeaderHeight();
            } else {
                // Open the search bar
                searchBar.classList.add('search-bar--open');
                searchBar.style.display = 'block';
                searchBar.style.maxHeight = '200px';
                updateHeaderHeight();
            }
        });
    }

    updateHeaderHeight();

    if (searchBar && searchBar.length > 0) {
        if (usesSpeedCart === true || usesSpeedCart === "true" || usesSpeedCart === 1) {
            searchBar.addClass("search-bar--open");
            searchBar.css("display", "block");
        } else {
            searchBar.removeClass("search-bar--open");
            searchBar.css("display", "none");
        }
    }

    // Handle fabric only search toggle
    if (searchesFabricsOnly === true || searchesFabricsOnly === "true" || searchesFabricsOnly === 1) {
        let availableSearchForms = document.querySelectorAll(".fabric-togglable-form");

        availableSearchForms.forEach(form => {
            let inputElement = document.createElement("input");

            inputElement.setAttribute("class", "fabric-only-search-filter");
            inputElement.setAttribute("name", "filter.p.product_type");
            inputElement.setAttribute("type", "hidden");
            inputElement.setAttribute("value", "Fabric");

            form.appendChild(inputElement);
        });
    } else {
        let fabricOnlyFilters = document.querySelectorAll(".fabric-only-search-filter");

        fabricOnlyFilters.forEach(filter => {
            filter.remove();
        });
    }

    const currency = $('#price-multiplier').attr("currency");
    const locale = $('#price-multiplier').attr("locale");
    const currencyClass = new Intl.NumberFormat(locale, { style: 'currency', currency: currency });

    priceUnitEl.each(function(index) {
        if (getToggleStatus == 'Off')
            $(this).addClass('hide-pricing');
        else
            $(this).removeClass('hide-pricing');
    });

    priceEl.each(function(index) {
        if (getToggleStatus == 'Off') {
            $(this).addClass('hide-pricing');
            $(this).parents('.carton-pricing').addClass('hide-pricing');
            $(this).parents('.subtotal').addClass('hide-pricing');
            $(this).parents('.cart-bar-total').addClass('hide-pricing');
            $('#shopping-cart .product-info--pre-order').hide();
            $('#cartform .carton-item-price').hide();
            $('#cartform .item-price').hide();
            $('#cartform .total-price').hide();
            $(this).parents('#shopping-cart .cart-price').addClass('hide-pricing');
            $(this).parents('#shopping-cart .cart-total').addClass('hide-pricing');
            $(this).parents('#shopping-cart .cart-summary').addClass('hide-pricing');
            $('.price-type').addClass('hide-pricing');
            $('.m2m-from-price').addClass('hide-pricing');
            $('.m2m-calculated-price').addClass('hide-pricing');
        } else {
            $(this).removeClass('hide-pricing');
            $(this).parents('.carton-pricing').removeClass('hide-pricing');
            $(this).parents('.subtotal').removeClass('hide-pricing');
            $(this).parents('.cart-bar-total').removeClass('hide-pricing');
            $('#shopping-cart .product-info--pre-order').show();
            $('#cartform .carton-item-price').show();
            $('#cartform .item-price').show();
            $('#cartform .total-price').show();
            $(this).parents('#shopping-cart .cart-price').removeClass('hide-pricing');
            $(this).parents('#shopping-cart .cart-total').removeClass('hide-pricing');
            $(this).parents('#shopping-cart .cart-summary').removeClass('hide-pricing');
            $('.price-type').removeClass('hide-pricing');
            $('.m2m-from-price').removeClass('hide-pricing');
            $('.m2m-calculated-price').removeClass('hide-pricing');
        }

        var variantPrice = $(this).attr('data-price');
        var multiplierPrice = variantPrice * getMultiplier;
        var m2mPrice = $('.m2m-calculated-price').attr('data-price');
        var m2mMultiplierPrice = m2mPrice * getMultiplier;

        if (getMultiplier > 1) {
            multiplierPrice = Math.ceil((multiplierPrice / 100).toFixed(2)) * 100;
            m2mMultiplierPrice = Math.ceil((m2mMultiplierPrice / 100).toFixed(2)) * 100;
        }

        // Handle the price adjustment for fabric variants when the various
        // price settings are toggled on/off.
        if ($(this)[0].closest('.variant-fabric-cut') && $(this)[0].closest('.variant-title') || $(this).attr('data-fabric-cut')) {
            variantPrice *= 10;
            multiplierPrice *= 10;
            m2mPrice *= 10;
            m2mMultiplierPrice *= 10;
        }

        let variantPriceFormatted = currencyClass.format((variantPrice / 100).toFixed(2));
        let multiplierPriceFormatted = currencyClass.format((multiplierPrice / 100).toFixed(2));

        if(currency === "EUR") {
            variantPriceFormatted = variantPriceFormatted.replace('.', ',');
            multiplierPriceFormatted = multiplierPriceFormatted.replace('.', ',');
        }

        let priceType;

        switch(locale) {
            default:
                priceType = "Unit Price (Ex. VAT)";
                break;
        }

        if (getMultiplier > 1) {
            $(this).text(multiplierPriceFormatted);
            $('.price-type').text(priceType);

            if(m2mPrice != '') {
                let m2mCalcMultiplierPrice = (m2mMultiplierPrice / 100).toFixed(2);

                if(currency === "EUR") {
                    m2mCalcMultiplierPrice = m2mCalcMultiplierPrice.replace('.', ',');
                }

                $('.m2m-calculated-price').text(currencyClass.format(m2mCalcMultiplierPrice));
            }
        } else if (getMultiplier == 1) {
            $(this).text(variantPriceFormatted);
            $('.price-type').text(priceType);

            if(m2mPrice != '') {
                let m2mCalcPrice = (m2mPrice / 100).toFixed(2);

                if(currency === "EUR") {
                    m2mCalcPrice = m2mCalcPrice.replace('.', ',');
                }

                $('.m2m-calculated-price').text(currencyClass.format(m2mCalcPrice));
            }
        }
    });

    var hiddenPrices = $('.hide-pricing');
    if (getToggleStatus != 'Off') {
        hiddenPrices.each(function(index) {
            $(this).removeClass('hide-pricing');
        });
    }

    document.body.classList.remove("js-drawer-open-right-price");

    let priceSettings = document.getElementById("price-settings");
    if (priceSettings && typeof priceSettings !== "undefined")
        priceSettings.classList.remove("show-price-settings");
}

// Update price settings on save
const savePriceSettings = document.getElementById('save-price-settings');

if (savePriceSettings) {
    savePriceSettings.addEventListener('click', function() {
        savePriceSettings.setAttribute('value', 'Please wait...');
        setTimeout(function() {
            window.location.reload();
        }, 2000);
    });
}

// Apply price settings to collections
const collectionContent = document.getElementById('collection-content');
if (collectionContent) {
    window.addEventListener('load', (event) => {
        applyPriceSettings();
    });
}

// Reset price settings
function clearPriceSettings() {
    const priceToggle = $('.price-toggle input[value="On"]');
    const priceMultiplier = $('#price-multiplier');
    const cartTypeTrue = $('.cart-type-toggle input[value="true"]');
    const cartTypeFalse = $('.cart-type-toggle input[value="false"]');

    priceToggle.prop('checked', true);
    priceMultiplier.val(1);
    cartTypeTrue.prop('checked', false);
    cartTypeFalse.prop('checked', true);
}

const resetPriceSettings = document.getElementById('reset-price-settings');

if (resetPriceSettings) {
    resetPriceSettings.addEventListener('click', function() {
        clearPriceSettings();

        resetPriceSettings.setAttribute('value', 'Please wait...');

        setTimeout(function() {
            window.location.reload();
        }, 2000);
    });
}



// Variant individual / carton tabs
var tabHeading = document.querySelectorAll('.tab-heading');
tabHeading.forEach(function(heading) {
    heading.addEventListener('click', function() {
        var contentId = this.dataset.bind;
        $(this).parent().find('.tab-heading').removeClass('active-tab');
        $(this).addClass('active-tab');
        //$('.variant-tab').removeClass('active-tab');
        $(this).parent().siblings('.tab-content').find('.variant-tab').removeClass('active-tab');
        $(this).parent().siblings('.tab-content').find('.m2m-tab').removeClass('active-tab');
        //$('.variant-tab[data-bind="' + contentId + '"').addClass('active-tab');
        $(this).parent().siblings('.tab-content').find('.variant-tab[data-bind="' + contentId + '"]').addClass('active-tab');
        $(this).parent().siblings('.tab-content').find('.m2m-tab[data-bind="' + contentId + '"]').addClass('active-tab');

        let addToCartButton = $(this).closest('form').find('button.add-to-cart-button');

        if (addToCartButton.length) {
            if ($(this).attr('data-bulk-cta'))
                addToCartButton.addClass('visually-hidden');
            else
                addToCartButton.removeClass('visually-hidden');
        }

        // Update min max info
        var form = $(this).parent().siblings('.tab-content').find('.m2m-tab[data-bind="' + contentId + '"]');
        var minMaxMeta = $('.m2m-min-max', form);
        var minWidth = minMaxMeta.attr('data-min-width');
        var maxWidth = minMaxMeta.attr('data-max-width');
        var minDrop = minMaxMeta.attr('data-min-drop');
        var maxDrop = minMaxMeta.attr('data-max-drop');
        var infoMinWidth = $('.m2mMinWidth');
        var infoMaxWidth = $('.m2mMaxWidth');
        var infoMinDrop = $('.m2mMinDrop');
        var infoMaxDrop = $('.m2mMaxDrop');

        infoMinWidth.html(minWidth + 'cm');
        infoMaxWidth.html(maxWidth + 'cm');
        infoMinDrop.html(minDrop + 'cm');
        infoMaxDrop.html(maxDrop + 'cm');

        // Switch units back to CM
        var unitsInput = $('.m2mUnits');
        unitsInput.val('cm');

        // Clear validation error css
        $('.m2mWidth').removeClass('validation-error');
        $('.m2mDrop').removeClass('validation-error');
        $('.size-info').removeClass('validation-error');
        $('.size-info-icon').html('<i class="fa fa-info-circle"></i>');

        // Unhide eyelets
        $('.m2mEyeletsIllustrated').parents('.curtain-option-wrapper').removeClass('hidden');

        m2mResetForm('full');
    });
});

// Quick Quote app format line item properties
$(document).ready(function() {
    $('#quick-quote-wrapper [data-title]').each(function() {
        $(this).text($(this).text().replace(/_/g, ' '));
    });
});

/**
 * Navigation Interactions
 */
let childMenuButtons = document.querySelectorAll('.mobile-drawer-link'),
    grandchildMenuButtons = document.querySelectorAll('button.show-grandchild-menu'),
    topLevelLinks = document.querySelectorAll('li.level-1'),
    backButtons = document.querySelectorAll('button.back-to-previous');

const DESKTOP_NAV_BREAKPOINT = 1000;

const navigationReset = (e) => {
    e.target.closest('li.active').classList.remove('active');
    topLevelLinks.forEach((link) => {
        link.style.display = 'list-item';
    });
}

/**
 * Open/Close Navigation Pane
 */
// Open
if(document.getElementById('burger-nav')) {
    document.getElementById('burger-nav').addEventListener('click', (e) => {
        e.stopPropagation();
        document.body.classList.add('nav-open');
    });
}
// Close
document.addEventListener("click", function(e) {
    if (e.target.classList.contains('close-nav')) {
        document.body.classList.remove('nav-open');
    } else if (!e.target.classList.contains('burger') && !e.target.classList.contains('trigger') && !e.target.closest('#main-menu')) {
        document.body.classList.remove('nav-open');
    }
}, false);

/**
 * Clicking a parent link that has children
 */
childMenuButtons.forEach((item) => {
    item.addEventListener('click', function(e) {
        topLevelLinks.forEach((link) => {
            if (link !== item.closest('li.has-children')) {
                link.style.display = 'none';
            } else {
                link.classList.add('active');
            }
        });
    });
});

/**
 * Opening the grandchild menu on click
 */
grandchildMenuButtons.forEach((item) => {
    item.addEventListener('click', function(e) {
        if(!item.classList.contains('on')) {
            grandchildMenuButtons.forEach((otherItem) => {
                otherItem.classList.remove('on');
                otherItem.closest('li').querySelector('ul.grandchild').classList.remove('active-grandchild-menu');
            })
        }
        item.classList.toggle('on');
        e.target.closest('li').querySelector('ul.grandchild').classList.toggle('active-grandchild-menu');
    });
});

/**
 * Click on back button
 */
backButtons.forEach((item) => {
    item.addEventListener('click', (e) => {
        navigationReset(e);
    })
});

// HoverIntent for desktop navigation
if ($(window).width() >= DESKTOP_NAV_BREAKPOINT) {
    $('li.level-1.has-children').hoverIntent({
        over: function() {
            if ($(window).width() >= DESKTOP_NAV_BREAKPOINT) {
                setTimeout(() => {
                    $(this).addClass('hovered');
                }, 100);
            }
        },
        out: function() {
            if ($(window).width() >= DESKTOP_NAV_BREAKPOINT) {
                setTimeout(() => {
                    $(this).removeClass('hovered');
                }, 150);
            }
        },
        timeout: 0
    });
}

// Touchscreen navigation hover
if (('ontouchstart' in window || navigator.maxTouchPoints) && window.matchMedia('(pointer: coarse)').matches) {
    document.querySelectorAll('li.level-1.has-children').forEach(item => {
        item.addEventListener('touchstart', function(e) {
            if (window.innerWidth < DESKTOP_NAV_BREAKPOINT) {
                if (!this.classList.contains('active')) {
                    e.preventDefault();
                    // Hide all other top-level links and remove .active
                    document.querySelectorAll('li.level-1').forEach(link => {
                        if (link !== this) {
                            link.style.display = 'none';
                            link.classList.remove('active');
                        } else {
                            link.classList.add('active');
                            link.style.display = 'list-item';
                        }
                    });
                }
            } else {
                if (!this.classList.contains('hovered')) {
                    e.preventDefault();
                    document.querySelectorAll('li.level-1.has-children.hovered').forEach(other => {
                        if (other !== this) {
                            other.classList.remove('hovered');
                        }
                    });
                    this.classList.add('hovered');
                }
            }
        });
    });
}

// Closes an open dropdown for the navigation
document.addEventListener('click', function(e) {
    // If the click target is not inside a hovered level-1 link,
    // remove the 'hovered' class from any that have it.
    if (!e.target.closest('li.level-1.has-children.hovered')) {
        document.querySelectorAll('li.level-1.has-children.hovered').forEach(item => {
            item.classList.remove('hovered');
        });
    }
});

/**
 * Info button js
 */

const allInfoButtons = document.querySelectorAll(".info-button");

const showInfoBox = (id, ajax) => {
    document.getElementById(`info-tooltip-${id}-ajax-${ajax}`).classList.add("info-tooltip-active");
}

const hideInfoBox = () => {
    document.querySelectorAll(".info-tooltip-active").forEach((tooltip) => {
        tooltip.classList.remove("info-tooltip-active");
    });
};

let activeVariant = null;
let activeAjax = null;

allInfoButtons?.forEach((infoButton) => {
    infoButton.addEventListener('click', (event) => {
        const variant = event.target?.getAttribute("variant");
        const ajax = event.target?.getAttribute("ajax");

        // Close currently open info box if it's different to the clicked one
        if (activeVariant !== null && (variant !== activeVariant || ajax !== activeAjax)) {
            hideInfoBox();
        }

        // Open the new box
        showInfoBox(variant, ajax);

        // Set the variables to the new box
        activeVariant = variant;
        activeAjax = ajax;

        document.getElementById(`info-tooltip-cross-${variant}-ajax-${ajax}`).addEventListener('click', hideInfoBox);
    })

    document.addEventListener('click', (event) => {
        // Guard against the info box closing when clicked
        if (!event.target.closest('.info-button-wrapper')) {
            hideInfoBox(event);
        }
    })
});

// Copy to clipboard function for the info buttons
function copyToClipboard(el) {
    var container = el.closest('.info-tooltip-text');
    var span = container.querySelector('span.info');

    // Prevent function from executing on the 'Copied to clipboard' text
    if (span.dataset.copying === "true") return;
    span.dataset.copying = "true";

    // Copy text
    var originalText = span.innerText;

    // Update text temporarily
    navigator.clipboard.writeText(originalText);

    span.innerText = "Copied to clipboard";

    // Revert after 2 seconds
    setTimeout(() => {
        span.innerText = originalText;
        span.dataset.copying = "false";
    }, 2000);
}

/**
 * Initialise Select2 for colour dropdowns on PDP
 */
jQuery(function($) {
    // Use a class instead of an ID for the dropdowns
    var $colourSwitcherDrops = $('.js-colour-switcher-drop');

    if ($colourSwitcherDrops.length > 0) {
        $colourSwitcherDrops.each(function() {
            $(this).select2({
                minimumResultsForSearch: Infinity,
                templateResult: formatState,
                templateSelection: formatState,
                width: 'style',
                dropdownCssClass: "circle",
                sorter: data => data.sort((a, b) => a.text.localeCompare(b.text))
            });
        });
    }
});

/**
 * Tempalte for the dropdown above
 */
function formatState(state)
{
    let swatchStyle = jQuery(state.element).attr('data-hex-style');
    let outline = jQuery(state.element).attr('data-hex-outline');
    if (outline != '') {
        outlineWidth = '4';
    } else {
        outlineWidth = '1';
    }

    if(typeof jQuery(state.element).attr('data-hex-colour') == 'undefined') {
        return state.text;
    }

    if (swatchStyle == 'half') {
        var $state = jQuery(
            '<span><span class="option-hex" style="\
                border: 1px solid #848484; \
                background-color: '+jQuery(state.element).attr('data-hex-colour')+';\
                background-image: -webkit-linear-gradient(-45deg, '+jQuery(state.element).attr('data-hex-colour')+' 0%, '+jQuery(state.element).attr('data-hex-colour')+' 50%, '+jQuery(state.element).attr('data-hex-outline')+' 50%, '+jQuery(state.element).attr('data-hex-outline')+' 50%); \
                background-image: linear-gradient(-webkit-linear-gradient(-45deg, '+jQuery(state.element).attr('data-hex-colour')+' 0%, '+jQuery(state.element).attr('data-hex-colour')+' 50%, '+jQuery(state.element).attr('data-hex-outline')+' 50%, '+jQuery(state.element).attr('data-hex-outline')+' 50%); \
            ">&nbsp;</span> ' + state.text + '</span>'
        )
    } else {
        var $state = jQuery(
        '<span><span class="option-hex" style="\
            border: ' + outlineWidth + 'px solid '+jQuery(state.element).attr('data-hex-outline')+'; \
            background-color: '+jQuery(state.element).attr('data-hex-colour')+';\
            '+(jQuery(state.element).attr('data-hex-outline') != "1px solid rgb(0, 0, 0)" ? 'min-height: 1.4rem; min-width: 1.4rem;' : '')+'\
        ">&nbsp;</span> ' + state.text + '</span>'
        );
    }

    return $state;
}

/**
 * Read more functionality
 * Covers any read more section that uses line-clamp
 * (i.e. directional hero)
 */
function toggleExpanded(event) {
    event.stopPropagation();
    const identifier = event.target.dataset.identifier;
    const textBody = document.querySelector(`.readmore__wrapper[data-identifier="${identifier}"] .readmore__body`);
    if (textBody) {
        const isExpanded = textBody.classList.contains('expanded');
        textBody.classList.toggle('expanded', !isExpanded);
        const readMoreButton = event.target;
        readMoreButton.textContent = isExpanded ? 'Read More' : 'Read Less';
    }
}

function checkAndDisplayReadMore() {
    const readMoreWrappers = document.querySelectorAll('.readmore__wrapper[data-identifier]');
    readMoreWrappers.forEach(readMoreWrapper => {
        const readMoreButton = readMoreWrapper.querySelector('.readmore__action');
        const textBody = readMoreWrapper.querySelector('.readmore__body');

        if (!textBody || !readMoreButton) {
            return; // Skip if elements are not found
        }

        const isTextClamped = () => {
            return textBody.scrollHeight > textBody.clientHeight;
        };

        readMoreButton.style.display = isTextClamped() ? 'inline-block' : 'none';

        if (readMoreButton.dataset.listener !== 'true') {
            readMoreButton.dataset.listener = 'true';
            readMoreButton.addEventListener('click', toggleExpanded);
        }
    });
}

document.addEventListener('DOMContentLoaded', function() {
    checkAndDisplayReadMore();
});

// Make carousel for desktop only for interpage links
function directionalCollectionLinks() {
    if (document.querySelector('#interpage-links:not(.flickity-enabled)')) {
        const collectionCarousel = document.getElementById('interpage-links');
        let arrColChildren = Array.from(collectionCarousel.children);
        let options = '';

        if (window.innerWidth >= 1220) {
            switch (arrColChildren.length) {
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    options = {
                        cellAlign: 'center',
                        contain: true,
                        freeScroll: false,
                        draggable: false,
                        pageDots: false,
                        prevNextButtons: false
                    }
                    break;
                default:
                    options = {
                        cellAlign: 'left',
                        contain: true,
                        freeScroll: true,
                        wrapAround: true,
                        pageDots: true,
                        imagesLoaded: true,
                        watchCSS: true
                    }
                    break;
            }
            let collectionCar = new Flickity(collectionCarousel, options);
        } else {
            let collectionCar = new Flickity(collectionCarousel);
            collectionCar.destroy();
        }
    } else {
        return;
    }
}

/**
 * Loop to add all image filters to carousels
 */
function initImageCarousels() {
    const imageCarousels = document.querySelectorAll('[data-carousel-type="image"]');
    let totalWidth = 0;

    imageCarousels.forEach(imageCarousel => {
        // set some local variables per carousel
        let arrImageChildren = Array.from(imageCarousel.children);
        let wrapperWidth = imageCarousel.offsetWidth;
        let totalWidth = 0;
        let imageCar;

        // loop through the children of the carousel and get their widths
        arrImageChildren.forEach(child => {
            totalWidth = totalWidth + child.offsetWidth; // add the widths
        });

        // compare the total width of the children against the width of the container
        if (totalWidth > wrapperWidth || arrImageChildren.length > 5) {
            imageCar = new Flickity(imageCarousel, {
                // options
                cellAlign: 'left',
                contain: true,
                freeScroll: true,
                watchCSS: true,
                wrapAround: true,
                pageDots: true,
                imagesLoaded: true
            });
        } else {
            imageCarousel.classList.add('no-scroll');
            imageCar = new Flickity(imageCarousel);
            imageCar.destroy();
        }

        // reset!
        totalWidth = 0;
        wrapperWidth = 0;
    });
}

/**
 * Loop to add all text filters to carousels
 */
function initTextCarousels() {
    var textCarousels = document.querySelectorAll('[data-carousel-type="text"]');

    textCarousels.forEach(textCarousel => {
        var arrTextChildren = Array.from(textCarousel.children);

        if (arrTextChildren.length > 5) {
            var textCar = new Flickity(textCarousel, {
                // options
                cellAlign: 'left',
                contain: true,
                freeScroll: true,
                watchCSS: true,
                wrapAround: true,
                pageDots: true,
                imagesLoaded: true
            });
        }
    });
}

/**
 * Loop to add all swatch filters to carousels
 * mobile only
 */
function initSwatchCarousels() {
    if (document.querySelectorAll('[data-carousel-type="swatch"]')) {
        const swatchCarousels = document.querySelectorAll('[data-carousel-type="swatch"]');

        swatchCarousels.forEach(swatchCarousel => {
            let swatchCar = new Flickity(swatchCarousel, {
                // options
                cellAlign: 'left',
                contain: true,
                freeScroll: true,
                wrapAround: true,
                pageDots: true,
                imagesLoaded: true,
                watchCSS: true
            });
        });
    } else {
        return;
    }
}

/**
 * Loop to add product lists to carousels
 */
function initProductCarousels() {
    const productCarousels = document.querySelectorAll('[data-carousel-type="product"]');
    let totalWidth = 0;

    productCarousels.forEach(productCarousel => {
        // set some local variables per carousel
        let arrProductChildren = Array.from(productCarousel.children);
        let wrapperWidth = productCarousel.offsetWidth;
        let totalWidth = 0;
        let productCar;

        // loop through the children of the carousel and get their widths
        arrProductChildren.forEach(child => {
            totalWidth = totalWidth + child.offsetWidth; // add the widths
        });

        // compare the total width of the children against the width of the container
        if (window.innerWidth <= 1025 || arrProductChildren.length > 4) {
            productCar = new Flickity(productCarousel, {
                // options
                cellAlign: 'left',
                contain: true,
                freeScroll: true,
                wrapAround: true,
                pageDots: true,
                imagesLoaded: true
            });
        } else {
            productCar = new Flickity(productCarousel);
            productCar.destroy();
        }

        // reset!
        totalWidth = 0;
        wrapperWidth = 0;
    });
}

document.addEventListener('DOMContentLoaded',() => {
    initTextCarousels();
    initSwatchCarousels();
    initImageCarousels();
    directionalCollectionLinks();
});

var prevWidth = window.innerWidth;
window.addEventListener('resize', () => {
    if (window.innerWidth !== prevWidth ) {
        prevWidth = window.innerWidth;
        initTextCarousels();
        initSwatchCarousels();
        initImageCarousels();
        directionalCollectionLinks();
    }
});

document.addEventListener('DOMContentLoaded', function () {
    /**
     * FAQ Accordions
     */
    // Function to collapse all faq__answers
    function collapseAllAnswers(faqSection) {
        const items = faqSection.querySelectorAll('.faq__item');
        items.forEach(item => {
            item.classList.remove('open');
            item.querySelector('.faq__answer').style.display = 'none';
        });
    }

    // Function to handle the click event
    function handleQuestionClick(event) {
        const faqSection = event.target.closest('.faq__section');
        const faqItem = event.target.closest('.faq__item');
        const answer = faqItem.querySelector('.faq__answer');

        if (faqItem.classList.contains('open')) {
            // If it's already open, close it
            faqItem.classList.remove('open');
            answer.style.display = 'none';
        } else {
            // Otherwise, close all and open the clicked one
            collapseAllAnswers(faqSection);
            faqItem.classList.add('open');
            answer.style.display = 'block';
        }
    }

    // Initialize the accordion
    const faqSections = document.querySelectorAll('.faq__section');

    faqSections.forEach(faqSection => {
        // Collapse all answers initially
        collapseAllAnswers(faqSection);

        // Add click event listeners to each question
        const questions = faqSection.querySelectorAll('.faq__question');
        questions.forEach(question => {
            question.addEventListener('click', handleQuestionClick);
        });
    });

    /**
     * FAQ Jumpers
     * Stealing the movement to account for the header overlapping the page
     */
    // Function to handle the smooth scroll with offset
    function scrollToElement(target) {
        const header = document.querySelector('#shopify-section-header');
        const headerHeight = header ? header.offsetHeight : 0; // Calculate header height dynamically

        const element = document.querySelector(target);
        if (element) {
            const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - headerHeight;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth' // Smooth scrolling
            });
        }
    }

    // Apply offset when a link with .move-link class is clicked
    document.querySelectorAll('.move-link').forEach(anchor => {
        anchor.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent the default jump
            const target = anchor.getAttribute('href');
            scrollToElement(target);
        });
    });

    // Apply offset if page loads with a hash in the URL
    if (location.hash.length !== 0) {
        scrollToElement(location.hash);
    }

    /**
     * Future Stock Toggle Handler
     * Handle expanding/collapsing the future stock section
     */
    function toggleFutureStock($trigger) {
        const $variantItem = $trigger.closest('.variant-item');
        const $futureStock = $variantItem.find('.variant-item__future-stock');
        const $header = $trigger.closest('.variant-item__header');
        
        $futureStock.stop(true, false).slideToggle('fast', function() {
            // Sync the active class with the actual visibility state
            if ($futureStock.is(':visible')) {
                $header.addClass('active');
            } else {
                $header.removeClass('active');
            }
        });
    }

    function toggleInfoDropdown($trigger) {
        const $variantItem = $trigger.closest('.variant-item');
        const $variantInfo = $variantItem.find('.variant-item__info-dropdown');
        const $header = $trigger.closest('.variant-item__header');
        
        $variantInfo.stop(true, false).slideToggle('fast', function() {
            // Sync the active class with the actual visibility state
            if ($variantInfo.is(':visible')) {
                $header.addClass('info-active');
            } else {
                $header.removeClass('info-active');
            }
        });
    }

    // Click handler for the "more due soon" button
    $(document).on('click', '.variant-item-trigger', function(e) {
        e.preventDefault();
        toggleFutureStock($(this));
    });
    
    // Click handler for the 'Variant Info' button
    $(document).on('click', '.variant-item-info-trigger', function(e) {
        e.preventDefault();
        toggleInfoDropdown($(this));
    });

    // Click handler for the "load more" button
    $(document).on('click', '.future-stock-load-more-btn', function(e) {
        e.preventDefault();
        
        const $button = $(this);
        const $container = $button.closest('.variant-item__future-stock');
        const $hiddenItems = $container.find('.future-stock-hidden');
        
        // Show all hidden items with a slide effect
        $hiddenItems.slideDown('fast', function() {
            $(this).removeClass('future-stock-hidden');
        });
        
        // Hide the load more button
        $button.closest('.future-stock-load-more-container').slideUp('fast');
    });

    /**
     * Auto-expand future stock on page load if user has future date items in cart
     */
    function autoExpandFutureStock() {
        $('.variant-item').each(function() {
            const $variantItem = $(this);
            const $futureInputs = $variantItem.find('.future-quantity-input');
            
            // Check if any future stock items have quantity > 0
            let hasFutureStock = false;
            $futureInputs.each(function() {
                const qty = parseInt($(this).val()) || 0;
                if (qty > 0) {
                    hasFutureStock = true;
                    return false; // break the loop
                }
            });
            
            // If future stock exists, expand the section
            if (hasFutureStock) {
                const $futureStock = $variantItem.find('.variant-item__future-stock');
                const $header = $variantItem.find('.variant-item__header').first();
                $futureStock.show();
                $header.addClass('active');
            }
        });
    }

    // Run on page load
    autoExpandFutureStock();
});

// function initResizable () {
//     const width = window.innerWidth;

//     // New relocation logic for .product__sales.track
//     relocateProductSales(width);
// }

function relocateProductSales(width) {
    const sales = document.querySelector('.product__sales.track');
    if (!sales) return;

    if (width < 979) {
        const info = document.querySelector('.product__info');
        if (info) {
            const accordion = info.querySelector('.product__info-accordion');
            if (accordion) {
                if (sales.parentElement !== info || sales.nextElementSibling !== accordion) {
                    info.insertBefore(sales, accordion);
                }
            } else if (sales.parentElement !== info) {
                info.appendChild(sales);
            }
        }
    } else if (width > 980) {
        const wrapper = document.querySelector('.product__wrapper');
        if (wrapper && sales.parentElement !== wrapper) {
            wrapper.appendChild(sales);
        }
    }
    // Between 740 and 980 we leave the element where it last was (no spec provided)
}

window.addEventListener('resize', () => relocateProductSales(window.innerWidth));
window.addEventListener('DOMContentLoaded', () => relocateProductSales(window.innerWidth));

function productBackground(variants) {
    // Change the background colour 
    // e.g. so that if 2 & 4 are the only active items, they are white and grey instead of both grey

    variants.forEach((el, index) => {
        if (index % 2 === 0) {
            el.style.backgroundColor = '#f7f7f7';
        } else {
            el.style.backgroundColor = 'white';
        }
    });
}

function setPDPListTop() {
    const header = document.querySelector('.stickyheader');
    const sidebar = document.querySelector('.slideable');
    const searchBar = document.getElementById('search-bar');
    
    if (header && sidebar) {
        const headerHeight = header.offsetHeight;
        // Add an additional 16px/1rem if search bar is hidden
        const topPosition = headerHeight + 16;
        sidebar.style.top = topPosition + 'px';
    }
}

// Run on page load
setPDPListTop();

// Re-calculate on window resize
window.addEventListener('resize', setPDPListTop);